<template>
  <div style="background-color: #f4fbff; height: 100vh">
    <audio :key="callRingRenderKey" ref="callRing" id="callRingId" autoplay loop playsinline @ended="callRingEnd"></audio>
    <audio ref="msgRing" id="msgRingId" autoplay playsinline @ended="msgRingEnd"></audio>
    <router-view ref="routerView" v-show="!videoShow" @callTeam="callTeam" @callUser="callUser" @dzAndroid="dzAndroid"
      @monitor="monitor" @initRing="initRing" @doMethods = "doMethods"
     id="router" />
    <Audio ref="recordComponents"></Audio>
    <!-- 来电提示 -->
    <div class="popup-call" v-show="receiveCallList.length > 0">
      <div class="popup-call_inner" v-for="(item, index) in receiveCallList.slice(0, 3)" :key="index">
        <template v-if="item.method == 'promptAlert'">
          <div class="popup-call_name" style="
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
            ">
            <span class="popup-label">{{ item.call_user_name }}</span>
            <span class="popup-label">(見守りセンサーaams)</span>
            <span class="popup-label">{{ item.alertName }}</span>
          </div>
          <button @click="hangupCall(item)" class="call-btn call-btn_end">
            <div class="red-circle">対応不可</div>
          </button>
          <button @click="answerCall(item)" v-if="!item.showCall" class="call-btn call-btn_call">
            <div class="green-circle">対応する</div>
          </button>
        </template>
        <template v-else-if="item.method == 'smartpeepAlert'">
          <div class="popup-call_name" style="
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
            ">
            <span class="popup-label">{{ item.alertName + " " + getAIStatusName(item.status) }}
            </span>
            <span class="popup-label">お呼び出し中</span>
          </div>
          <button @click="hangupCall(item)" class="call-btn call-btn_end">
            <div class="red-circle">対応不可</div>
          </button>
          <button @click="answerCall(item)" class="call-btn call-btn_call">
            <div class="green-circle">対応する</div>
          </button>
        </template>
        <template v-else-if="item.method == 'onlyButtonCall'">
          <div class="popup-call_name" style="
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
            ">
            <span class="popup-label" style="width: 100%; font-size: 1.3rem">{{
              item.call_user_name
              }}</span>
            <span v-if="item.button_doctors" class="popup-label">お呼び出し中(ボタンのみ)</span>
            <span v-else class="popup-label">お呼び出し中(ボタン)</span>
          </div>
          <button @click="hangupCall(item)" class="call-btn call-btn_end">
            <div v-if="item.button_doctors" class="red-circle">対応不可</div>
            <img v-else src="@/assets/img/common/call_end.png" alt="" />
          </button>
          <button @click="answerCall(item)" v-if="!item.showCall" class="call-btn call-btn_call">
            <div v-if="item.button_doctors" class="green-circle">対応する</div>
            <img v-else src="@/assets/img/common/call_talk.png" alt="" />
          </button>
        </template>
        <template v-else-if="item.method == 'multiCall'">
          <div class="popup-call_name">
            <span>{{ item.call_user_name }}(複数)から</span>
            <span class="state">お呼び出ししています</span>
          </div>
          <button @click="hangupCall(item)" class="call-btn call-btn_end">
            <img src="@/assets/img/common/call_end.png" alt="" />
          </button>
          <button @click="answerCall(item)" class="call-btn call-btn_call">
            <img src="@/assets/img/common/call_talk.png" alt="" />
          </button>
        </template>
        <template v-else>
          <p class="popup-call_name">
            <span>{{ item.call_user_name }}</span>
            <span class="state">お呼び出ししています{{ item.aiDangerCode }}</span>
          </p>
          <button @click="hangupCall(item)" class="call-btn call-btn_end">
            <img src="@/assets/img/common/call_end.png" alt="" />
          </button>
          <button @click="answerCall(item)" v-if="!item.showCall" class="call-btn call-btn_call">
            <img src="@/assets/img/common/call_talk.png" alt="" />
          </button>
        </template>
      </div>
    </div>
    <div class="popContainer" v-show="showMask"></div>
    <div v-if="showWaitDialogFlg">
      <van-dialog v-model:show="showWaitDialogFlg" theme="round-button" show-cancel-button cancel-button-color="red"
        @cancel="cancelCall" :show-confirm-button="false">
        <div style="
            text-align: center;
            padding: 2rem;
            display: flex;
            justify-content: center;
          ">
          <span> 呼び出し中 </span>
          <van-loading color="blue" size="18px" type="circular" />
        </div>
      </van-dialog>
    </div>
    <div v-if="noticeVisable" class="page-app-noticeArea">
      <van-dialog
        v-model:show="noticeVisable"
        :show-confirm-button="false"
        theme="round-button"
        :show-cancel-button="false"
        :closeOnClickOverlay="false"
        @click.stop
      >
        <div ref="noticeDialogWrap" class="notice_dialog" :style="noticeDialogWrapStyle">
          <div ref="noticePanel" class="notice_panel" :style="noticePanelStyle">
            <div ref="noticeTitle" class="notice_title" :style="noticeTitleStyle">
              <span>{{ noticeItem.title }}</span>
            </div>
            <div
              v-if="noticeIsScroll"
              ref="noticeContentFrame"
              class="notice_content notice_content_scroll"
              :style="[noticeContentAreaStyle, noticeScrollFrameStyle]"
            >
              <div
                ref="noticeScrollTrack"
                class="notice_content_track"
                :style="noticeScrollStyle"
              >
                <div
                  ref="noticeScrollText"
                  class="notice_scroll_text"
                  :style="noticeScrollTextStyle"
                >
                  {{ noticeNormalizedContent || "\u00A0" }}
                </div>
              </div>
            </div>
            <div v-else class="notice_content notice_content_static">
              <div
                ref="noticeContentStatic"
                class="notice_static"
                :style="[noticeContentAreaStyle, noticeStaticContentStyle]"
              >
                <span
                  ref="noticeContentSpan"
                  :style="noticeStaticTextStyle"
                  >{{ noticeItem.content }}</span
                >
              </div>
            </div>
          </div>
          <button
            ref="noticeCloseButton"
            type="button"
            class="notice_close_button"
            :style="noticeCloseButtonStyle"
            @click.stop="closeNotice"
          >
            <span class="notice_close_button-icon" :style="noticeCloseButtonIconStyle">x</span>
            <span>閉じる</span>
          </button>
          <div ref="noticeLeaveShow" class="notice_leave_show" :style="noticeLeaveShowStyle">
            <span>{{ noticeItem.show_end_str }}後に自動オフ</span>
          </div>
        </div>
      </van-dialog>
    </div>
  </div>
  <DzAndroid ref="dzAndroid" @dzAndroid="dzAndroid"></DzAndroid>
  <Monitor ref="monitor" @monitor="monitor" />
</template>
<script>
  import Audio from "@/components/Audio";
  import DzAndroid from "@/components/DzAndroid";
  import Monitor from "@/components/Monitor";
  import { Dialog, Loading, Toast } from "vant";
  import { GetPatientDetails } from "@/services/patient";
  import {
    LoginedOut,
    Logout,
    SaveFcmToken,
    SaveRefreshToken,
  } from "@/services/user";
  import Janus from "@/assets/js/janus";
  import { checkAuthorization } from "@/utils/request";
  import { contactSocket, doSend } from "@/utils/websocket";
  import { loginIgnore } from "@/router";
  import { CheckLoginRequest, RefreshUserInfo } from "@/services/login";
  import { GetDoctorDetail } from "@/services/team";
  import { randNumStr, randPwd } from "@/utils/rand";
  import {
    changeMessageStatus,
    checkMessage,
    pushMessage,
  } from "@/services/pushmessage";
  import { getAudioList, saveCallLog, saveVideoRecord } from "@/services/video";
  import { CloseNotice, GetPatientChat } from "@/services/chatrecord";
  import { speakText, stopSpeakText } from "@/utils/tts";

  import adapter from "webrtc-adapter";
  import jquery from "jquery";
  import { GetRingingFile } from "@/services/ringing";
  import { getAIStatusName } from "@/utils/getName";

  window.JQuery = jquery;
  window.adapter = adapter;

  export default {
    name: "App",
    components: { Audio, [Loading.name]: Loading, DzAndroid, Monitor },
    data() {
      return {
        callStatus: "",
        isBackgroundMode: false,
        showTestDialog: false,
        videoShow: false,
        type: "",
        screenWidth: null,
        showTop: false,
        showMask: false,
        roomattach: null,
        roomTimer: null,
        //避免没有收到返回时，重复刷新
        needRefresh: true,
        ignoreRefresh: {
          names: ["404", "403"], //根据路由名称匹配
          paths: ["/login", "/verification", "/verifyUserLoginId"], //根据路由fullPath匹配
          includes(route) {
            return (
              this.names.includes(route.name) || this.paths.includes(route.path)
            );
          },
        },
        isIos: true,
        monitorattch: null,
        // websocket连接flg
        webSocketHasRegisted: false,
        //拨打的状态值
        callingStatus: "normal",
        // 拨打者用信息
        call_data: {
          // 通话id
          call_id: "",
          // 顺序拨打用户
          call_sort_userids: [],
          // 一齐拨打用户
          call_userids: [],
          // 离线拨打标识
          offLineCall: false,
          call_offLine_userids: [],
        },
        //接听者用信息
        inCallingInfo: {
          call_user_name: "",
        },
        // 离线拨打用
        offLineInterval: null,
        inOffLineCalling: false,
        // 通话信息,record日志用的信息
        logMessage: null,
        timeout: null,
        //响铃状态
        callRingStatus: false,
        callRingBlob: null,
        callRingRenderKey: 0,
        callRingPlayRetryTimer: null,
        //主动拨打时，长时间没有回复，那么需要挂断

        // 登录请求弹窗显示
        login_request_timeout: null,
        login_request_uid: null,

        // 呼出等待
        showWaitDialogFlg: false,

        // 保存refreshtoken到logindevice标识
        loginDeviceSaveFlg: false,
        loginDeviceInterval: null,

        // monitor修改为后台
        monitorRoom: "",

        // 按钮来电提示框
        showCallTeam_timer: null,

        lastReadId: "",
        noticeItem: {},
        noticeInterval: null,
        noticeVisable: false,
        noticeColor: "white",
        noticeScrollFrameHeightPx: 0,
        noticeScrollLineHeightPx: 0,
        noticeScrollTranslateXPx: 0,
        noticeScrollAnimationDurationMs: 0,
        noticeScrollFrameWidthPx: 0,
        noticeScrollTextWidthPx: 0,
        noticeScrollShouldAnimate: false,
        noticeScrollTransitionEnabled: false,
        noticeScrollTimer: null,
        noticeScrollReady: false,
        noticeStaticMaxHeightPx: 0,
        noticeViewportWidthPx: 0,
        noticeViewportHeightPx: 0,
        noticeViewportLayoutKey: "",
        noticeViewportChangeTimer: null,
        noticeLayoutRetryTimers: [],
        // 保存来电组
        receiveCallList: [],
        autoAnswerTimer: {},
        autoHangupTimer: {},
        // 针对拨打着的挂断，同时只能拨打一个 不需要object
        hangupTimer: null,
        // 按钮来点组
        showCallTeamList: [],
        musicSrc: "",
        musicSrcLast: "",
        musicBlob: null,
        msgMusicSrc: "",
        msgMusicSrcLast: "",
        msgMusicBlob: null,
        //自动关闭弹窗
        noAnswerDialogInterval: null,
        // 网络状况监测的dialog
        dialogInstance: null,
        netOnline: true,

        // indexeddb
        dbConnection: null,

        // 多人通话参数
        multicallWaitUser:null,

        // 录音功能
        isRecordingAudio:false,
        fullScreenCallFontSize: 2,
        controlledReloadPending: false,
      };
    },
      created() {
      setInterval(() => {
        if (checkAuthorization()) {
          //1小时 刷新一次 避免一些问题
          //部分页面不能刷新
          this.refreshPage(false);
        }
      }, 1000 * 60 * 60);

      //checkIsNeedRestart
      setInterval(() => {
        if (checkAuthorization()) {
          //1小时 刷新一次 避免一些问题
          //部分页面不能刷新
          this.checkIsNeedRestart();
        }
      }, 1000 * 60);

      this.iosOrAndroid();
      //优化ios,android,pc的权限检测!
      //直接通过webrtc来检测权限
      //5s 之后再申请。避免重复申请！

      //ios 不需要申请权限，应该会自动申请的
      let timeout = 1000;
      if (!this.isIos) {
        setTimeout(() => {
          if (
            typeof cordova !== "undefined" &&
            cordova.plugins &&
            cordova.plugins.permissions
          ) {
            this.checkAndroidPermission();
          } else {
            this.checkDevicePermission();
          }
        }, timeout);
      }
      // 网络定期检测
        this.netWorkCheck();
      },
      beforeUnmount() {
        window.removeEventListener(
          "tsunagaru-request-reload",
          this.handleReloadRequest
        );
        window.removeEventListener("resize", this.queueNoticeViewportMetricsChange);
        window.removeEventListener(
          "orientationchange",
          this.queueNoticeViewportMetricsChange
        );
        if (window.visualViewport) {
          window.visualViewport.removeEventListener(
            "resize",
            this.queueNoticeViewportMetricsChange
          );
        }
        this.clearNoticeViewportChangeTimer();
        this.clearNoticeLayoutRetryTimers();
        this.clearNoticeScrollTimer();
        stopSpeakText();
      },
      mounted() {
      this.syncFullScreenCallFontSize();
      window.addEventListener(
        "tsunagaru-request-reload",
        this.handleReloadRequest
      );
      this.applyNoticeViewportMetrics();
      window.addEventListener("resize", this.queueNoticeViewportMetricsChange);
      window.addEventListener(
        "orientationchange",
        this.queueNoticeViewportMetricsChange
      );
      if (window.visualViewport) {
        window.visualViewport.addEventListener(
          "resize",
          this.queueNoticeViewportMetricsChange
        );
      }
      // window.appV = this;
      // 长按菜单
      document.addEventListener("contextmenu", function (e) {
        e.preventDefault();
      });
      // 保存uuid
      let num = 0;
      this.loginDeviceInterval = setInterval(() => {
        num++;
        if (num > 10) {
          if (this.loginDeviceInterval) {
            clearInterval(this.loginDeviceInterval);
          }
          return;
        }
        // 是在有权限的页面
        if (!this.ignoreRefresh.includes(this.$route) && checkAuthorization()) {
          // 只执行一次
          if (!this.loginDeviceSaveFlg) {
            // 获取refreshtoken
            let refreshtoken = localStorage.getItem("refreshtoken");
            if (
              refreshtoken !== undefined &&
              refreshtoken != null &&
              refreshtoken !== "" &&
              typeof device !== "undefined" &&
              device.uuid !== null &&
              typeof device.uuid !== "undefined"
            ) {
              let platform = "";
              let url = window.location.href;
              if (url.indexOf("ios-") !== -1) {
                platform = "ios";
              } else if (url.indexOf("android-") !== -1) {
                platform = "android";
                // 启动前台服务,先暂停前台服务
                setTimeout(() => {
                  cordova.plugins.backgroundMode.disable();
                }, 2000);
                //disable
                try {
                  setTimeout(() => {
                    let userInfo = JSON.parse(
                      localStorage.getItem(process.env.VUE_APP_USER_KEY)
                    );
                    cordova.plugins.backgroundMode.enable(
                      userInfo.login_account_id + "_service"
                    );
                  }, 5000);
                } catch (e) {
                  console.log(e);
                }
              } else if (url.indexOf("web-") !== -1) {
                platform = "web";
              } else if (url.indexOf("pc-") !== -1) {
                platform = "pc";
              } else if (url.indexOf("localhost-") !== -1) {
                platform = "localhost";
              }
              SaveRefreshToken({
                platform: platform,
                uuid: device.uuid,
                refreshToken: refreshtoken,
              });
              this.loginDeviceSaveFlg = true;
            }
          } else {
            if (this.loginDeviceInterval) {
              clearInterval(this.loginDeviceInterval);
            }
          }
        }
      }, 500);

      this.screenWidth = document.body.clientWidth;
      window.onresize = () => {
        return (() => {
          this.screenWidth = document.body.clientWidth;
        })();
      };
      //通知相关的
      window.saveFcmToken = this.saveFcmToken;
      window.jumpPage = this.jumpPage;
      // this.watchOffLineEvent();
      this.checkOffLineMessageTimer();
      document.addEventListener(
        "pause",
        () => {
          this.isBackgroundMode = true;
        },
        false
      );
      document.addEventListener(
        "resume",
        () => {
          this.isBackgroundMode = false;
          this.checkOffLineMessageTimer();
        },
        false
      );

      // 定期权限检测看看是否登录过期了
      setInterval(() => {
        if (!checkAuthorization()) {
          let refreshtoken = localStorage.getItem("refreshtoken");
          if (
            refreshtoken !== undefined &&
            refreshtoken != null &&
            refreshtoken !== ""
          ) {
            if (this.needRefresh && this.netOnline) {
              this.requestControlledReload({ reason: "auth_check_failed" });
            }
          }
          return;
        }
      }, 5000);

      // 防止漏掉了发送的消息 初始化时查询一次消息
      let userInfo = JSON.parse(
        localStorage.getItem(process.env.VUE_APP_USER_KEY)
      );
      if (
        !this.ignoreRefresh.includes(this.$route) &&
        userInfo &&
        userInfo.type == "5"
      ) {
        if (checkAuthorization()) {
          let refreshtoken = localStorage.getItem("refreshtoken");
          if (
            refreshtoken !== undefined &&
            refreshtoken != null &&
            refreshtoken !== ""
          ) {
            // 查询消息
            this.initNotice();
            // AI分析检测-慢速
            this.monitor({
              toPage: "monitor",
              method: "startAiAnalysis",
              time: 5000,
            });
          }
          return;
        }
      }
    },
      methods: {
      syncFullScreenCallFontSize() {
        try {
          const user = JSON.parse(
            localStorage.getItem(process.env.VUE_APP_USER_KEY)
          );
          this.fullScreenCallFontSize =
            Number(user?.full_screen_call_font_size) || 2;
        } catch (error) {
          this.fullScreenCallFontSize = 2;
        }
      },
      resetNoticeScrollState() {
        this.clearNoticeScrollTimer();
        this.noticeScrollFrameHeightPx = 0;
        this.noticeScrollLineHeightPx = 0;
        this.noticeScrollTranslateXPx = 0;
        this.noticeScrollAnimationDurationMs = 0;
        this.noticeScrollFrameWidthPx = 0;
        this.noticeScrollTextWidthPx = 0;
        this.noticeScrollShouldAnimate = false;
        this.noticeScrollTransitionEnabled = false;
        this.noticeScrollReady = false;
      },
      test() { },
      handleReloadRequest(event) {
        const detail = event?.detail || {};
        this.requestControlledReload(detail);
      },
      requestControlledReload(detail = {}) {
        if (this.controlledReloadPending) {
          return;
        }
        this.controlledReloadPending = true;
        const routeComponent = this.$store.state.routeViewComponent;
        const needRestart = detail.needRestart === true;
        const doReload = () => {
          if (needRestart) {
            this.restartAndroidApp();
          } else {
            window.location.reload();
          }
        };
        if (this.checkPage("/singleCall")) {
          if (routeComponent && typeof routeComponent.doHangup === "function") {
            routeComponent.clickHangupFlg = true;
            routeComponent.doHangup();
            setTimeout(() => {
              doReload();
            }, 1500);
            return;
          }
        }
        if (this.checkPage("/roomConversation")) {
          if (routeComponent && typeof routeComponent.doHungUp === "function") {
            routeComponent.doHungUp();
            setTimeout(() => {
              doReload();
            }, 1500);
            return;
          }
        }
        doReload();
      },
      doMethods(params){
        if(params['method'] == "changeRecordAudioStatus"){
          this.isRecordingAudio = params['value'];
        }else if(params['method'] == "playMsgRinging"){
          this.playMsgRinging();
        }
      },
      isCordovaIosWebView() {
        return !!(
          window.cordova &&
          window.cordova.platformId === "ios" &&
          window.webkit &&
          window.webkit.messageHandlers
        );
      },
      prepareIosAudioSessionForRing(callback) {
        const done = typeof callback === "function" ? callback : () => {};
        if (!this.isCordovaIosWebView() || !window.IosAudioSession) {
          done();
          return;
        }
        let completed = false;
        const finish = () => {
          if (completed) {
            return;
          }
          completed = true;
          done();
        };
        const timeout = setTimeout(finish, 800);
        try {
          window.IosAudioSession.prepareForRing(
            () => {
              clearTimeout(timeout);
              finish();
            },
            (error) => {
              clearTimeout(timeout);
              console.log("prepare ios audio session for ring failed:", error);
              finish();
            }
          );
        } catch (error) {
          clearTimeout(timeout);
          console.log("prepare ios audio session for ring failed:", error);
          finish();
        }
      },
      getCallRingElement() {
        return this.$refs.callRing || document.getElementById("callRingId");
      },
      clearCallRingPlayRetry() {
        if (this.callRingPlayRetryTimer) {
          clearTimeout(this.callRingPlayRetryTimer);
          this.callRingPlayRetryTimer = null;
        }
      },
      resetAudioElement(audio, clearSrc = false) {
        if (!audio) {
          return;
        }
        try {
          audio.pause();
        } catch (error) {
          console.log(error);
        }
        try {
          audio.currentTime = 0;
        } catch (error) {
          console.log(error);
        }
        if (clearSrc) {
          try {
            audio.removeAttribute("src");
            audio.load();
          } catch (error) {
            console.log(error);
          }
        }
      },
      resetCallRingAudio({ rebuild = false } = {}) {
        this.clearCallRingPlayRetry();
        this.resetAudioElement(this.getCallRingElement(), true);
        this.musicSrcLast = "";
        if (rebuild) {
          this.callRingRenderKey++;
        }
      },
      prepareCallRingAudioElement() {
        this.setMusicSrc();
        const audio = this.getCallRingElement();
        if (!audio) {
          return null;
        }
        const src = this.musicBlob || this.musicSrc;
        if (!src) {
          return null;
        }
        this.resetAudioElement(audio, false);
        audio.loop = true;
        audio.playsInline = true;
        if (audio.getAttribute("src") !== src) {
          audio.src = src;
        }
        this.musicSrcLast = this.musicBlob ? "" : this.musicSrc;
        try {
          audio.load();
          audio.currentTime = 0;
        } catch (error) {
          console.log(error);
        }
        return audio;
      },
      playCallRingAudio(audio, allowRetry = true) {
        if (!audio) {
          return;
        }
        const playResult = audio.play();
        if (!playResult || typeof playResult.catch !== "function") {
          return;
        }
        playResult.catch((error) => {
          console.log("call ring play failed:", error);
          if (!allowRetry || !this.callRingStatus) {
            return;
          }
          this.clearCallRingPlayRetry();
          this.callRingPlayRetryTimer = setTimeout(() => {
            this.callRingPlayRetryTimer = null;
            if (!this.callRingStatus) {
              return;
            }
            if (this.isIos) {
              this.callRingRenderKey++;
            }
            this.$nextTick(() => {
              this.playCallRingAudio(this.prepareCallRingAudioElement(), false);
            });
          }, 300);
        });
      },
      startCallRingAudio() {
        if (!this.callRingStatus) {
          return;
        }
        this.clearCallRingPlayRetry();
        // iOS WebViewではBluetooth経路が残ることがあるため、来電ごとにaudio要素を作り直す。
        if (this.isIos) {
          this.resetCallRingAudio({ rebuild: true });
          this.$nextTick(() => {
            this.playCallRingAudio(this.prepareCallRingAudioElement());
          });
          return;
        }
        this.playCallRingAudio(this.prepareCallRingAudioElement());
      },
      stopCallRingAudio() {
        this.callRingStatus = false;
        this.resetCallRingAudio({ rebuild: this.isIos });
      },
      getAIStatusName(status) {
        return getAIStatusName(status);
      },
      joinMultiCallRoom(roomId) {
        this.$router.push({
          path: "/roomConversation",
          query: {
            id: roomId,
            room_id: roomId,
            mikeOpen: false,
            cameraOpen: false,
            multiCall:true,
          },
        });
      },
      async deleteDatabase() {
        // 没有使用 备用 删除本地数据库
        return new Promise((resolve, reject) => {
          let request = window.indexedDB.deleteDatabase("tsunagaru");
          request.onsuccess = function () {
            console.log("数据库已成功删除");
            resolve();
          };
          request.onerror = function (event) {
            console.error("删除数据库失败", event.target.error);
            reject(event.target.error);
          };
          request.onblocked = function () {
            console.warn(
              "数据库删除被阻止，请确保没有打开的数据库连接或标签页正在使用数据库"
            );
            alert("请关闭其他标签页或刷新页面后重试，数据库删除被阻止。");
          };
        });
      },
      async openDB() {
        if (this.dbConnection) {
          return this.dbConnection;
        }
        return new Promise((resolve, reject) => {
          let request = window.indexedDB.open("tsunagaru", 2);
          request.onerror = function (event) {
            console.log(event);
            reject("error: can't open database");
          };
          request.onsuccess = (event) => {
            this.dbConnection = request.result;
            resolve(this.dbConnection);
          };
          request.onupgradeneeded = function (event) {
            let db = event.target.result;
            if (!db.objectStoreNames.contains("ringings")) {
              // 仅在对象存储不存在时创建
              db.createObjectStore("ringings", { keyPath: "type" });
            }
            if (!db.objectStoreNames.contains("backgrounds")) {
              db.createObjectStore("backgrounds", { keyPath: "name" });
            }
          };
        });
      },
      async initRing() {
        let filename = "";
        let msgFilename = "";
        let userInfo = JSON.parse(
          localStorage.getItem(process.env.VUE_APP_USER_KEY)
        );
        if (userInfo.video_path && userInfo.video_path !== "") {
          filename = userInfo.video_path;
        } else {
          filename = "default.mp3";
        }
        if (userInfo.video_path_msg && userInfo.video_path_msg !== "") {
          msgFilename = userInfo.video_path_msg;
        } else {
          msgFilename = "msgDefault.mp3";
        }
        let db = await this.openDB();
        let transaction = db.transaction(["ringings"]);
        let objectStore = transaction.objectStore("ringings");
        // ring
        let request = objectStore.get("call");
        request.onsuccess = async (event) => {
          const result = event.target.result;
          if (
            result &&
            result.filename &&
            result.filename == filename &&
            result.blob.size > 10
          ) {
            const audioUrl = URL.createObjectURL(result.blob);
            this.musicBlob = audioUrl;
          } else {
            const response = await GetRingingFile(filename);
            const audioBlob = new Blob([response.data], { type: "audio/mpeg" });
            if (audioBlob.size > 10) {
              const audioUrl = URL.createObjectURL(audioBlob);
              this.musicBlob = audioUrl;
              let transaction = db.transaction(["ringings"], "readwrite");
              let objectStore = transaction.objectStore("ringings");
              objectStore.put({
                type: "call",
                filename: filename,
                blob: audioBlob,
              });
            } else {
              this.setMusicSrc();
            }
          }
        };
        request.onerror = (event) => {
          // 数据库异常
          console.log(event);
          this.setMusicSrc();
        };
        // msg
        let request2 = objectStore.get("msg");
        request2.onsuccess = async (event) => {
          const result2 = event.target.result;
          if (
            result2 &&
            result2.filename &&
            result2.filename == msgFilename &&
            result2.blob.size > 10
          ) {
            const audioUrl2 = URL.createObjectURL(result2.blob);
            this.msgMusicBlob = audioUrl2;
          } else {
            const response2 = await GetRingingFile(msgFilename);
            const audioBlob2 = new Blob([response2.data], { type: "audio/mpeg" });
            if (audioBlob2.size > 10) {
              const audioUrl2 = URL.createObjectURL(audioBlob2);
              this.msgMusicBlob = audioUrl2;
              let transaction = db.transaction(["ringings"], "readwrite");
              let objectStore = transaction.objectStore("ringings");
              objectStore.put({
                type: "msg",
                filename: msgFilename,
                blob: audioBlob2,
              });
            } else {
              this.setMusicSrc();
            }
          }
        };
        request.onerror = (event) => {
          // 数据库异常
          console.log(event);
          this.setMusicSrc();
        };
      },
      netWorkCheck() {
        // 监听网络恢复
        window.addEventListener("online", () => {
          this.netOnline = true;
          if (this.dialogInstance) {
            this.dialogInstance.close();
            this.dialogInstance = null;
          }
        });

        // 监听网络断开
        window.addEventListener("offline", () => {
          this.netOnline = false;
          this.createDialogInstance();
        });
      },
      createDialogInstance() {
        // 如果对话框已经存在，则不重复创建
        if (this.dialogInstance) return;
        this.dialogInstance = Dialog.alert({
          title: "ネットワークエラー",
          confirmButtonText: "再読み込み",
          message:
            "インターネットに接続できませんでした。\n" +
            "通信環境や端末の設定をご確認の上、\n" +
            "再度おためしてください。",
        });
        this.dialogInstance.then(() => {
          if (this.netOnline) {
            // 网络恢复时关闭对话框
            this.dialogInstance = null;
          } else {
            this.dialogInstance = null;
            this.createDialogInstance();
          }
        });
        this.dialogInstance.close = () => {
          if (this.dialogInstance) {
            // 通过触发按钮的点击事件来关闭对话框
            document.querySelector(".van-dialog__confirm").click();
          }
        };
      },
      msgRingEnd() {
        // 播放完消息提示音 检测是否需要播放msg
        if (this.noticeItem?.read_type == "1") {
          this.readNotice(this.noticeItem.content);
        }
      },
      initNotice() {
        // 获取自身(患者)接到的通知
        GetPatientChat().then((res) => {
          if (res.data.data && res.data.data.length > 0) {
            this.syncFullScreenCallFontSize();
            let item = res.data.data[0];
            this.noticeItem = {
              ...item,
              animationDuration: 5,
            };
            this.resetNoticeScrollState();
            this.noticeStaticMaxHeightPx = 0;
            this.noticeViewportLayoutKey = "";
            if (this.lastReadId != item.id) {
              if (this.noticeIsScroll) {
                this.noticeColor = "transparent";
              } else {
                this.noticeColor = "black";
              }
              this.lastReadId = this.noticeItem.id;
              this.noticeVisable = true;
              setTimeout(() => {
                if (!this.noticeVisable) {
                  return;
                }
                if (this.noticeIsScroll) {
                  this.prepareNoticeScrollAnimation();
                } else {
                  this.prepareNoticeStaticLayout();
                }
                this.scheduleNoticeLayoutRetry();
              }, 300);
              // 重置倒计时
              if (this.noticeInterval) {
                clearInterval(this.noticeInterval);
                this.noticeInterval = null;
              }
              this.noticeInterval = setInterval(() => {
                this.updateNoticeTime();
              }, 1000);
            }
          } else {
            this.noticeViewportLayoutKey = "";
            this.clearNoticeViewportChangeTimer();
            this.clearNoticeLayoutRetryTimers();
            this.resetNoticeScrollState();
            this.noticeStaticMaxHeightPx = 0;
            this.noticeVisable = false;
          }
        });
      },
      updateNoticeTime() {
        if (this.noticeItem && this.noticeItem.show_end_time) {
          const now = Date.now();
          const target = Date.parse(this.noticeItem.show_end_time);
          let totalSecondsRemaining = Math.floor((target - now) / 1000);
          let daysRemaining = Math.floor(totalSecondsRemaining / (24 * 3600));
          totalSecondsRemaining %= 24 * 3600;
          let hoursRemaining = Math.floor(totalSecondsRemaining / 3600);
          totalSecondsRemaining %= 3600;
          let minutesRemaining = Math.floor(totalSecondsRemaining / 60);
          let secondsRemaining = totalSecondsRemaining % 60;
          let show_end_str = "";
          if (daysRemaining > 0) {
            show_end_str += daysRemaining + "日";
          }
          if (hoursRemaining > 0) {
            show_end_str += hoursRemaining + "時";
          }
          if (minutesRemaining > 0) {
            show_end_str += minutesRemaining + "分";
          }
          if (secondsRemaining > 0) {
            show_end_str += secondsRemaining + "秒";
          }
          this.noticeItem.show_end_str = show_end_str;
          // 本条要关闭了
          if (
            daysRemaining == 0 &&
            hoursRemaining == 0 &&
            minutesRemaining == 0 &&
            secondsRemaining == 0
          ) {
            this.noticeVisable = false;
            this.noticeViewportLayoutKey = "";
            this.clearNoticeViewportChangeTimer();
            this.clearNoticeLayoutRetryTimers();
            this.resetNoticeScrollState();
            this.noticeStaticMaxHeightPx = 0;
            if (this.noticeInterval) {
              clearInterval(this.noticeInterval);
              this.noticeInterval = null;
            }
            this.initNotice();
          }
        }
      },
      readNotice(content) {
        speakText(content);
      },
      readCssPxVariable(name) {
        const value = parseFloat(
          window.getComputedStyle(document.documentElement).getPropertyValue(name)
        );
        return Number.isFinite(value) ? value : 0;
      },
      getNoticeViewportMetrics() {
        const fallbackWidth =
          window.innerWidth || document.documentElement.clientWidth || 0;
        const fallbackHeight =
          window.innerHeight || document.documentElement.clientHeight || 0;
        const visualViewport = window.visualViewport;
        const viewportWidth =
          visualViewport && Number.isFinite(visualViewport.width)
            ? visualViewport.width
            : fallbackWidth;
        const viewportHeight =
          visualViewport && Number.isFinite(visualViewport.height)
            ? visualViewport.height
            : fallbackHeight;
        const visualTop =
          visualViewport && Number.isFinite(visualViewport.offsetTop)
            ? visualViewport.offsetTop
            : 0;
        const visualBottom = Math.max(
          fallbackHeight - viewportHeight - visualTop,
          0
        );

        return {
          viewportWidth: Math.max(viewportWidth, 0),
          viewportHeight: Math.max(viewportHeight, 0),
          visualTop: Math.max(visualTop, 0),
          visualBottom,
          safeAreaTop: this.readCssPxVariable("--tsunagaru-safe-area-top"),
          safeAreaBottom: this.readCssPxVariable("--tsunagaru-safe-area-bottom"),
        };
      },
      applyNoticeViewportMetrics() {
        const metrics = this.getNoticeViewportMetrics();
        const rootStyle = document.documentElement.style;
        const isLandscape = metrics.viewportWidth > metrics.viewportHeight;
        const isUltraShortViewport =
          metrics.viewportHeight <= 280 ||
          (isLandscape && metrics.viewportHeight <= 360);
        const isCompactViewport =
          !isUltraShortViewport &&
          (metrics.viewportHeight <= 360 ||
            (isLandscape && metrics.viewportHeight <= 460));
        const topReserve =
          isUltraShortViewport
            ? metrics.safeAreaTop > 0
              ? 4
              : isLandscape
                ? 6
                : 8
            : isCompactViewport
              ? metrics.safeAreaTop > 0
                ? 6
                : isLandscape
                  ? 10
                  : 14
              : metrics.safeAreaTop > 0
                ? isLandscape
                  ? 10
                  : 12
                : this.isIos
                  ? isLandscape
                    ? 24
                    : 34
                  : isLandscape
                    ? 12
                    : 14;
        const bottomReserve =
          isUltraShortViewport
            ? metrics.safeAreaBottom > 0
              ? 4
              : 6
            : isCompactViewport
              ? metrics.safeAreaBottom > 0
                ? 6
                : 8
              : metrics.safeAreaBottom > 0
                ? isLandscape
                  ? 8
                  : 12
                : isLandscape
                  ? 10
                  : 12;
        rootStyle.setProperty(
          "--tsunagaru-notice-viewport-width",
          metrics.viewportWidth + "px"
        );
        rootStyle.setProperty(
          "--tsunagaru-notice-viewport-height",
          metrics.viewportHeight + "px"
        );
        rootStyle.setProperty(
          "--tsunagaru-notice-visual-top",
          metrics.visualTop + "px"
        );
        rootStyle.setProperty(
          "--tsunagaru-notice-visual-bottom",
          metrics.visualBottom + "px"
        );
        rootStyle.setProperty(
          "--tsunagaru-notice-top-reserve",
          topReserve + "px"
        );
        rootStyle.setProperty(
          "--tsunagaru-notice-bottom-reserve",
          bottomReserve + "px"
        );
        this.noticeViewportWidthPx = metrics.viewportWidth;
        this.noticeViewportHeightPx = metrics.viewportHeight;
        return metrics;
      },
      getNoticeViewportLayoutKey(metrics) {
        const viewportWidth = Math.round(metrics?.viewportWidth || 0);
        const viewportHeight = Math.round(metrics?.viewportHeight || 0);
        return viewportWidth + "x" + viewportHeight;
      },
      clearNoticeViewportChangeTimer() {
        if (this.noticeViewportChangeTimer) {
          clearTimeout(this.noticeViewportChangeTimer);
          this.noticeViewportChangeTimer = null;
        }
      },
      clearNoticeLayoutRetryTimers() {
        if (!this.noticeLayoutRetryTimers || this.noticeLayoutRetryTimers.length === 0) {
          this.noticeLayoutRetryTimers = [];
          return;
        }
        this.noticeLayoutRetryTimers.forEach((timerId) => {
          clearTimeout(timerId);
        });
        this.noticeLayoutRetryTimers = [];
      },
      scheduleNoticeLayoutRetry() {
        this.clearNoticeLayoutRetryTimers();
        if (!this.noticeVisable || !this.noticeIsScroll) {
          return;
        }
        const timerId = setTimeout(() => {
          this.noticeLayoutRetryTimers = this.noticeLayoutRetryTimers.filter(
            (item) => item !== timerId
          );
          if (!this.noticeVisable || !this.noticeIsScroll) {
            return;
          }
          this.handleViewportMetricsChange(true, true);
        }, 220);
        this.noticeLayoutRetryTimers.push(timerId);
      },
      queueNoticeViewportMetricsChange() {
        this.clearNoticeViewportChangeTimer();
        this.noticeViewportChangeTimer = setTimeout(() => {
          this.noticeViewportChangeTimer = null;
          this.handleViewportMetricsChange();
        }, 90);
      },
      handleViewportMetricsChange(force = false, keepRetryTimers = false) {
        const metrics = this.applyNoticeViewportMetrics();
        const viewportLayoutKey = this.getNoticeViewportLayoutKey(metrics);
        if (!force && viewportLayoutKey === this.noticeViewportLayoutKey) {
          return;
        }
        this.noticeViewportLayoutKey = viewportLayoutKey;
        this.handleNoticeLayoutChange(keepRetryTimers);
        if (!keepRetryTimers) {
          this.scheduleNoticeLayoutRetry();
        }
      },
      getNoticeLayoutMetrics() {
        const noticeDialogWrap = this.$refs.noticeDialogWrap;
        const noticePanel = this.$refs.noticePanel;
        const noticeTitle = this.$refs.noticeTitle;
        const noticeCloseButton = this.$refs.noticeCloseButton;
        const noticeLeaveShow = this.$refs.noticeLeaveShow;
        const dialogRootElement =
          noticeDialogWrap && typeof noticeDialogWrap.closest === "function"
            ? noticeDialogWrap.closest(".van-dialog")
            : null;
        const dialogContainer =
          dialogRootElement ||
          (noticeDialogWrap && noticeDialogWrap.parentElement
            ? noticeDialogWrap.parentElement
            : null);

        if (
          !noticeDialogWrap ||
          !noticePanel ||
          !noticeTitle ||
          !noticeCloseButton ||
          !noticeLeaveShow ||
          !dialogContainer
        ) {
          return null;
        }

        const panelStyle = window.getComputedStyle(noticePanel);
        const dialogStyle = window.getComputedStyle(dialogContainer);
        const panelPaddingY =
          parseFloat(panelStyle.paddingTop) + parseFloat(panelStyle.paddingBottom);
        const dialogPaddingY =
          parseFloat(dialogStyle.paddingTop) + parseFloat(dialogStyle.paddingBottom);
        const titleHeight = noticeTitle.offsetHeight;
        const controlsHeight =
          noticeCloseButton.offsetHeight + noticeLeaveShow.offsetHeight + 20;
        const dialogRect = dialogContainer.getBoundingClientRect();
        const viewportMetrics = this.applyNoticeViewportMetrics();
        const panelRect = noticePanel.getBoundingClientRect();
        const wrapRect = noticeDialogWrap.getBoundingClientRect();
        const widthCandidates = [
          Math.ceil(noticePanel.clientWidth || 0),
          Math.ceil(panelRect.width || 0),
          Math.ceil(noticeDialogWrap.clientWidth || 0),
          Math.ceil(wrapRect.width || 0),
          Math.ceil(viewportMetrics.viewportWidth || 0),
        ].filter((value) => value > 0);
        const viewportWidth =
          widthCandidates.length > 0
            ? Math.min(
                Math.max(...widthCandidates),
                Math.ceil(viewportMetrics.viewportWidth || 0)
              )
            : Math.ceil(viewportMetrics.viewportWidth || 0);
        const viewportHeight = Math.ceil(
          viewportMetrics.viewportHeight ||
            dialogContainer.clientHeight ||
            dialogRect.height ||
            0
        );
        const edgeReserve = viewportWidth > viewportHeight ? 14 : 10;
        const maxDialogInnerHeight = Math.max(
          viewportHeight - dialogPaddingY,
          0
        );
        const chromeReserve = controlsHeight + edgeReserve;
        const maxPanelHeight = Math.max(
          maxDialogInnerHeight - chromeReserve,
          titleHeight + panelPaddingY + 16
        );
        const maxContentHeight = Math.max(
          maxPanelHeight - titleHeight - panelPaddingY - 16,
          0
        );

        return {
          viewportWidth,
          viewportHeight,
          maxContentHeight,
        };
      },
      handleNoticeLayoutChange(keepRetryTimers = false) {
        if (!this.noticeVisable) {
          return;
        }
        if (!keepRetryTimers) {
          this.clearNoticeLayoutRetryTimers();
        }
        this.noticeStaticMaxHeightPx = 0;
        this.resetNoticeScrollState();
        if (!this.noticeIsScroll) {
          this.prepareNoticeStaticLayout(false);
          return;
        }
        this.prepareNoticeScrollAnimation(false);
      },
      prepareNoticeStaticLayout(shouldPlayAudio = true) {
        this.$nextTick(() => {
          requestAnimationFrame(() => {
            const noticeContentSpan = this.$refs.noticeContentSpan;
            const noticeContentStatic = this.$refs.noticeContentStatic;
            const layoutMetrics = this.getNoticeLayoutMetrics();

            if (!noticeContentSpan || !noticeContentStatic || !layoutMetrics) {
              if (shouldPlayAudio) {
                this.playMsgRinging();
              }
              return;
            }

            const textStyle = window.getComputedStyle(noticeContentSpan);
            const contentStyle = window.getComputedStyle(noticeContentStatic);
            const lineHeight = parseFloat(textStyle.lineHeight);
            const safeLineHeight = Number.isFinite(lineHeight)
              ? lineHeight
              : 48;
            const availableHeight = Math.max(
              layoutMetrics.maxContentHeight - (parseFloat(contentStyle.marginTop) || 0),
              safeLineHeight * this.noticeMinVisibleLines
            );
            this.noticeStaticMaxHeightPx = Math.ceil(availableHeight);
            if (shouldPlayAudio) {
              this.playMsgRinging();
            }
          });
        });
      },
      prepareNoticeScrollAnimation(shouldPlayAudio = true) {
        this.$nextTick(() => {
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              const noticeContentFrame = this.$refs.noticeContentFrame;
              const noticeScrollText = this.$refs.noticeScrollText;
              const layoutMetrics = this.getNoticeLayoutMetrics();

              if (
                !noticeContentFrame ||
                !noticeScrollText ||
                !layoutMetrics
              ) {
                this.noticeColor = "black";
                if (shouldPlayAudio) {
                  this.playMsgRinging();
                }
                return;
              }

              const textStyle = window.getComputedStyle(noticeScrollText);
              const lineHeight = parseFloat(textStyle.lineHeight);
              const safeLineHeight = Number.isFinite(lineHeight)
                ? lineHeight
                : this.noticeScrollLineHeightPxValue;
              const clipPadding = Math.max(
                Math.ceil(safeLineHeight * 0.12),
                4
              );
              const frameWidth = Math.max(
                Math.ceil(
                  noticeContentFrame.clientWidth ||
                  noticeContentFrame.getBoundingClientRect().width ||
                  layoutMetrics.viewportWidth ||
                  0
                ),
                0
              );
              const textWidth = Math.max(
                Math.ceil(
                  noticeScrollText.scrollWidth ||
                  noticeScrollText.getBoundingClientRect().width ||
                  0
                ),
                0
              );
              const shouldAnimate = frameWidth > 0 && textWidth > frameWidth + 4;
              const frameHeight = Math.max(
                Math.ceil(safeLineHeight + clipPadding * 2),
                safeLineHeight
              );
              const travelDistance = Math.max(frameWidth + textWidth, 0);
              const animationDurationMs = shouldAnimate
                ? Math.min(
                    Math.max(Math.round((travelDistance / 150) * 1000), 5000),
                    45000
                  )
                : 0;

              this.noticeScrollLineHeightPx = safeLineHeight;
              this.noticeScrollFrameHeightPx = frameHeight;
              this.noticeScrollFrameWidthPx = frameWidth;
              this.noticeScrollTextWidthPx = textWidth;
              this.noticeScrollShouldAnimate = shouldAnimate;
              this.noticeScrollAnimationDurationMs = animationDurationMs;
              this.noticeScrollTranslateXPx = shouldAnimate ? frameWidth : 0;
              this.noticeScrollTransitionEnabled = false;
              this.noticeColor = "black";
              this.noticeScrollReady = true;
              if (shouldAnimate) {
                this.startNoticeScrollAnimation();
              }
              if (shouldPlayAudio) {
                this.playMsgRinging();
              }
            });
          });
        });
      },
      startNoticeScrollAnimation() {
        this.clearNoticeScrollTimer();
        if (
          !this.noticeVisable ||
          !this.noticeIsScroll ||
          !this.noticeScrollShouldAnimate
        ) {
          return;
        }
        const startPosition = this.noticeScrollFrameWidthPx;
        const endPosition = -this.noticeScrollTextWidthPx;
        this.noticeScrollTransitionEnabled = false;
        this.noticeScrollTranslateXPx = startPosition;
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            if (
              !this.noticeVisable ||
              !this.noticeIsScroll ||
              !this.noticeScrollShouldAnimate
            ) {
              return;
            }
            this.noticeScrollTransitionEnabled = true;
            this.noticeScrollTranslateXPx = endPosition;
              this.noticeScrollTimer = setTimeout(() => {
                if (
                  !this.noticeVisable ||
                  !this.noticeIsScroll ||
                  !this.noticeScrollShouldAnimate
              ) {
                return;
              }
              this.noticeScrollTransitionEnabled = false;
              this.noticeScrollTranslateXPx = startPosition;
              this.noticeScrollTimer = setTimeout(() => {
                this.startNoticeScrollAnimation();
              }, 180);
            }, this.noticeScrollAnimationDurationMs + 80);
          });
        });
      },
      clearNoticeScrollTimer() {
        if (this.noticeScrollTimer) {
          clearTimeout(this.noticeScrollTimer);
          this.noticeScrollTimer = null;
        }
      },
      closeNotice() {
        stopSpeakText();
        this.noticeViewportLayoutKey = "";
        this.clearNoticeViewportChangeTimer();
        this.clearNoticeLayoutRetryTimers();
        this.resetNoticeScrollState();
        this.noticeStaticMaxHeightPx = 0;
        this.noticeVisable = false;
        CloseNotice({ detail: { id: this.noticeItem.id, status: 1 } })
          .then(() => {
            this.initNotice();
          })
          .catch(() => {
            this.initNotice();
          });
      },
      monitor(params) {
        if (params["toPage"] == "app") {
          if (params["method"] == "setMyRoom") {
            this.monitorRoom = params["myroom"];
          }
        } else if (params["toPage"] == "monitor") {
          this.$refs.monitor.doMethods(params);
        } else if (params["toPage"] == "dzAndroid") {
          this.$refs.dzAndroid.doMethods(params);
        }
      },
      dzAndroid(params) {
        if (params["toPage"] == "dzAndroid") {
          // 如果处于监护模式 则不开启
          if (this.monitorRoom !== "") {
            return;
          }
          this.$refs.dzAndroid?.doMethods(params);
        } else if (
          params["toPage"] == "dzPage" &&
          this.$route.path == "/dzPage"
        ) {
          this.$store.dispatch("doMethods", params);
        }
      },
      checkOffLineMessageTimer() {
        if (!checkAuthorization()) {
          return;
        }
        let checkTime = 20;
        const checkOffTimer = setInterval(() => {
          checkTime--;
          if (checkTime === 0) {
            clearInterval(checkOffTimer);
          }
          if ("online" === localStorage.getItem("tsunagaru-websocket")) {
            this.checkOffLineMessage();
            clearInterval(checkOffTimer);
          }
        }, 1000);
      },
      async checkOffLineMessage() {
        // 查询是否有正在进行的离线电话
        let res = await checkMessage();
        let userInfo = JSON.parse(
          localStorage.getItem(process.env.VUE_APP_USER_KEY)
        );
        if (
          res.data.data &&
          res.data.data.status &&
          res.data.data.status == "hasUnComposed"
        ) {
          let msg = {
            send_type: "offLineCall",
            send_user: userInfo.login_account_id,
            to_users: [res.data.data.push_user],
          };
          setTimeout(() => {
            doSend(JSON.stringify(msg));
          }, 1000);
        } else if (
          res.data.data &&
          res.data.data.status &&
          res.data.data.status == "hasMultiUnComposed"
        ) {
          let msg = {
            send_type: "multiCall",
            type: "offLine",
            send_user: userInfo.login_account_id,
            to_users: [res.data.data.push_user],
          };
          setTimeout(() => {
            doSend(JSON.stringify(msg));
          }, 1000);
        }
      },
      callRingEnd() {
        // 铃声循环播放
        // this.$refs.callRing.play();
      },
      async initWebSocket() {
        let userRet = await RefreshUserInfo();
        let userInfo = userRet.data.data.user;
        localStorage.setItem(
          process.env.VUE_APP_USER_KEY,
          JSON.stringify(userInfo)
        );
        this.initRing();
        // 连接websocket
        let msg = {
          type: "create",
          login_account_id: userInfo.login_account_id,
        };

        contactSocket(this, JSON.stringify(msg));
        this.webSocketHasRegisted = true;
      },
      setMusicSrc() {
        let userInfo = JSON.parse(
          localStorage.getItem(process.env.VUE_APP_USER_KEY)
        );
        // 获取铃声
        if (userInfo.video_path && userInfo.video_path !== "") {
          this.musicSrc = "getRinging/" + userInfo.video_path;
        } else {
          this.musicSrc = "getRinging/default.mp3";
        }
        if (userInfo.video_path_msg && userInfo.video_path_msg !== "") {
          this.msgMusicSrc = "getRinging/" + userInfo.video_path_msg;
        } else {
          this.msgMusicSrc = "getRinging/msgDefault.mp3";
        }
        // if (process.env.NODE_ENV !== "development") {
        //   this.musicSrc = process.env.VUE_APP_API_BASE_URL + "/" + this.musicSrc;
        //   this.msgMusicSrc =
        //     process.env.VUE_APP_API_BASE_URL + "/" + this.msgMusicSrc;
        // } else {
        //   this.musicSrc = "api/" + this.musicSrc;
        //   this.msgMusicSrc = "api/" + this.msgMusicSrc;
        // }
        if (process.env.NODE_ENV !== "development") {
          this.musicSrc = "/" + this.musicSrc;
          this.msgMusicSrc = "/" + this.msgMusicSrc;
        } else {
          this.musicSrc = "api/" + this.musicSrc;
          this.msgMusicSrc = "api/" + this.msgMusicSrc;
        }
      },
      setCallingStatus(status) {
        //设置拨打的状态。
        //call：正在拨打给别人
        //beCalled: 正在被拨打电话，显示接听popup
        //inCalling: 通话中

        this.callingStatus = status;
      },
      initCallMsg(videoOrAudioCall, call_type) {
        //开始拨打时，初期化数据
        let call_id = randPwd(32);

        let msg = {
          call_id: call_id,
          call_type: call_type,
          videoOrAudioCall: videoOrAudioCall,
          to_users: [],
          send_type: "apply",
          offLineCall: false,
        };

        return msg;
      },
      showLoading() {
        //拨打时显示loading
        Toast.loading({
          duration: 0,
          forbidClick: true,
        });
      },
      clearLoading() {
        Toast.clear();
        // Dialog.close();
        this.showWaitDialogFlg = false;
      },
      showWaitingDialog() {
        Toast.clear();
        this.showWaitDialogFlg = true;
      },
      cancelCall() {
        let msg = {
          call_id: this.call_data.call_id,
          send_type: "outTime",
          to_users: this.call_data.to_users,
        };
        if (this.callStatus == "team") {
          console.log("team");
        } else {
          saveCallLog(msg);
        }
        let userInfo = JSON.parse(
          localStorage.getItem(process.env.VUE_APP_USER_KEY)
        );
        if (this.call_data.offLineCall) {
          changeMessageStatus({ to_user: userInfo.login_account_id }).then(
            () => { }
          );
          // inOffLineCalling说明虽然是离线拨打，但是此时对方已经上线了
          if (this.inOffLineCalling) {
            doSend(JSON.stringify(msg));
          }
        } else if (
          this.call_data.call_offLine_userids &&
          this.call_data.call_offLine_userids.length > 0
        ) {
          // 一齐拨打且有部分为离线
          changeMessageStatus({ to_user: userInfo.login_account_id }).then(
            () => { }
          );
          // 不止要处理离线的数据 还要把在线的弹窗给清了
          let msg = {
            call_id: this.call_data.call_id,
            send_type: "outTime",
            to_users: this.call_data.to_users,
          };
          doSend(JSON.stringify(msg));
        } else {
          doSend(JSON.stringify(msg));
        }
        this.endCallFlow("cancelBySelf", msg);
      },
      async callUser(type, chooseItem, mikeOpen, cameraOpen) {
        console.log("callUser");
        //一对一通话
        //检测现在是否是接听模式
        if (this.callingStatus != "normal") {
          return;
        }

        this.startCallFlow();
        let user;
        let to_user = chooseItem.id;
        let call_type;
        const userInfo = JSON.parse(
          localStorage.getItem(process.env.VUE_APP_USER_KEY)
        );

        // 呼叫患者：医生 -> 患者、家族 -> 患者
        if (chooseItem && chooseItem.type == "patient") {
          let res = await GetPatientDetails(chooseItem.id);
          user = res.data.data.detail;
          call_type = userInfo.type == "6" ? 7 : 2;
        } else if (chooseItem && chooseItem.type == "doctor") {
          //医生之间的拨打
          let res = await GetDoctorDetail(chooseItem.id);
          user = res.data.data.detail;
          call_type = 3;
        }

        let msg = this.initCallMsg(type, call_type);

        // 通话消息
        Object.assign(msg, {
          //拨打的对象
          to_users: [to_user],
          cameraOpen: cameraOpen,
          mikeOpen: mikeOpen,
          call_user: userInfo.login_account_id,
          call_user_name: userInfo.name,
          //自动接听flg
          answer_flg: userInfo.answer_flg,
          //自动接听时间
          auto_answer_time: userInfo.auto_answer_time,
        });

        if (user.online_status == "online") {
          // 在线
          if (user.calling_status != "3" && user.calling_status != "6") {
            // 不为空闲或者监视
            msg["no_answer"] = true;
            this.endCallFlow("busy", msg);
            return;
          }
        } else {
          // 有正在进行的离线拨打
          if (user.push_status != "can") {
            msg["no_answer"] = true;
            this.endCallFlow("cannotpush", msg);
            return;
          } else {
            // 需要离线拨打
            console.log("not online");
            msg["offLineCall"] = true;
            pushMessage({
              to_user: to_user,
              push_user: userInfo.name,
              call_type: call_type,
            });
          }
        }

        // 发送消息
        if (msg["offLineCall"]) {
          this.call_data = msg;
          this.startCallToUser(msg, true);
        } else {
          //保存拨打中的数据，仅仅是拨打者才有
          this.call_data = msg;
          this.startCallToUser(msg, false);
        }
        // 显示等待界面
        this.showWaitingDialog();
        //拨打的时候生成日志。
        saveCallLog(msg);
      },
      startCallToUser(msg, offline, times) {
        //修改状态
        this.setCallingStatus("call");

        //开启定时器
        if (!times) {
          this.setHangupTimer("caller", 60);
        } else {
          this.setHangupTimer("caller", times);
        }

        //发送消息
        if (!offline) {
          doSend(JSON.stringify(msg));
        }

        let service_list = [];
        msg["to_users"].forEach((item) => {
          service_list.push(item + "_service");
        });
        let service_msg = {
          to_service: service_list,
        };
        // 发送唤醒服务
        doSend(JSON.stringify(service_msg));
      },
      startCallFlow() {
        // 暂时暂停dz认证
        this.dzAndroid({ toPage: "dzAndroid", method: "temporaryStopDz" });
        //开始拨打者通话的流程
        this.showTestDialog = true;
        this.$store.commit("changeRefreshStatus", false);

        this.resetPage();

        this.showLoading();

        this.setCallingStatus("call");
      },
      endCallFlow(type, msg) {
        // 保存结束日志
        saveCallLog(msg);
        if (type !== "answer") {
          // 恢复dz认证
          this.dzAndroid({ toPage: "dzAndroid", method: "recoveryDz" });
        }
        //拨打结束应该有以下几种情况需要调用
        //1，无人可打
        //2，无人接听
        //3，有人接听了
        this.showTestDialog = false;

        //最特殊的：onlinetonotonline 拨打的时候在线，突然不在线了

        this.$store.commit("changeRefreshStatus", true);

        this.resetPage();
        // let noanswertext = "応答なし。"

        if (type == "notonline") {
          Toast("ユーザーはオンラインではありません、ユーザーに通知されました。");
        } else if (type == "noanswer") {
          this.showNoAnswerDialog();
        } else if (type == "busy") {
          this.showNoAnswerDialog();
        } else if (type == "answer") {
          //有人接听. 代表当前是正常流程进入的通话界面
          this.$store.commit("saveInCallingPage", true);
        } else if (type == "cannotpush") {
          this.showNoAnswerDialog();
        } else if (type == "cancelBySelf") {
          // do none
        } else if (type == "monitored") {
          Toast("相手は見守りモード。");
        } else {
          this.showNoAnswerDialog();
        }
        // Dialog.close();
        //并且可以根据type显示对应的消息！
      },
      showNoAnswerDialog() {
        // 清空全部的离线消息
        let userInfo = JSON.parse(
          localStorage.getItem(process.env.VUE_APP_USER_KEY)
        );
        changeMessageStatus({ to_user: userInfo.login_account_id }).then(
          () => { }
        );

        let countDownTime = 30;
        this.noAnswerDialogInterval = setInterval(() => {
          if (countDownTime === 0) {
            this.closeNoAnswerDialog();
          } else {
            Dialog.alert({
              message: "現在通話中\n後ほどお掛け直しください。",
              theme: "round-button",
              confirmButtonText: "キャンセル " + countDownTime + "秒",
              class: "noAnswerDialog",
            }).then(() => {
              this.closeNoAnswerDialog();
            });
            countDownTime--;
          }
        }, 1000);
      },
      closeNoAnswerDialog() {
        if (this.noAnswerDialogInterval) {
          Dialog.close(".noAnswerDialog");
          clearInterval(this.noAnswerDialogInterval);
          this.noAnswerDialogInterval = null;
        }
      },
      startAnswerFlow() {
        // 暂时暂停dz认证
        this.dzAndroid({ toPage: "dzAndroid", method: "temporaryStopDz" });
        //开启接听者的流程
        this.$store.commit("changeRefreshStatus", false);

        // this.resetPage();

        this.setCallingStatus("beCalled");

        this.showCallDialog();
      },
      endAnswerFlow(type) {
        this.$store.commit("changeRefreshStatus", true);

        if (type == "answer") {
          //接听的终止流程
          this.$store.commit("saveInCallingPage", true);
        } else {
          // 恢复dz认证
          this.dzAndroid({ toPage: "dzAndroid", method: "recoveryDz" });
        }
        //结束接听者的流程
        this.resetPage();
        this.closeCallDialog();
      },
      async callTeam(receiveMsgItem) {
        this.callStatus = "team";
        if (this.callingStatus != "normal") {
          return;
        }

        this.startCallFlow();

        let userRet = await RefreshUserInfo();
        let user = userRet.data.data.user;
        localStorage.setItem(process.env.VUE_APP_USER_KEY, JSON.stringify(user));

        //患者拨打时，默认是video模式， 类型为1
        let msg = this.initCallMsg("video", 1);

        Object.assign(msg, {
          call_user: user.login_account_id,
          call_user_name: user.name,
        });
        if (receiveMsgItem) {
          Object.assign(msg, { method: receiveMsgItem.method });
          if (receiveMsgItem.method == "promptAlert") {
            Object.assign(msg, {
              alertName: receiveMsgItem.alertName,
              call_type: 4,
            });
          }
        }
        saveCallLog(msg);
        let call_sort_userids = user.call_sort_userids;

        // 一齐拨打去重
        let call_userids = user.call_userids.filter(
          (item) => !user.call_sort_userids.includes(item)
        );

        //查找需要打给谁
        let to_users = [];
        let defaultCallTime = 60;
        if (user.call_by_sort && user.call_sort_userids.length > 0) {
          // 按顺序拨打
          for (let i = 0; i < user.call_sort_userids.length; i++) {
            let doctor = await GetDoctorDetail(user.call_sort_userids[i]);
            if (doctor.data.data.detail.online_status == "online") {
              // 在线
              if (
                doctor.data.data.detail.calling_status != "3" &&
                doctor.data.data.detail.calling_status != "6"
              ) {
                continue;
              }
            } else {
              if (doctor.data.data.detail.push_status !== "can") {
                continue;
              }
              msg["offLineCall"] = true;
            }
            // 对方为可通话状态
            if (doctor.data.data.detail.no_answer_flg == "1") {
              defaultCallTime = 999999;
            }
            to_users.push(user.call_sort_userids[i]);
            break;
          }

          // 顺序拨打无人可接听 继续执行全部拨打部分
          if (to_users.length >= 1) {
            msg["to_users"] = to_users;

            this.call_data = msg;
            this.call_data.call_userids = call_userids;
            this.call_data.call_sort_userids = call_sort_userids;

            // 显示等待界面
            this.showWaitingDialog();
            if (msg["offLineCall"]) {
              this.startCallToUser(msg, true);
              pushMessage({
                to_user: to_users,
                push_user: user.name,
                call_type: 1,
              });
            } else {
              this.startCallToUser(msg, false, defaultCallTime);
            }
            return;
          }
        }

        // 检测一齐拨打在线
        let call_offLine_userids = [];
        for (let i = 0; i < call_userids.length; i++) {
          let doctor = await GetDoctorDetail(call_userids[i]);
          if (doctor.data.data.detail.online_status == "online") {
            // 在线
            if (
              doctor.data.data.detail.calling_status != "3" &&
              doctor.data.data.detail.calling_status != "6"
            ) {
              continue;
            }
            to_users.push(doctor.data.data.detail.doctor_id);
          } else {
            if (doctor.data.data.detail.push_status !== "can") {
              continue;
            }
            call_offLine_userids.push(doctor.data.data.detail.doctor_id);
          }
          // 对方为可通话状态
          if (doctor.data.data.detail.no_answer_flg == "1") {
            defaultCallTime = 999999;
          }
        }

        if (to_users.length >= 1 || call_offLine_userids.length >= 1) {
          // 发送消息
          msg.to_users = to_users;
          this.call_data = msg;
          //这里必须使用to_users
          console.log("set this.call_data.call_userids");
          this.call_data.call_userids = to_users;
          console.log(this.call_data.call_userids);
          this.call_data.call_sort_userids = call_sort_userids;
          // 显示等待界面
          this.showWaitingDialog();
          if (to_users.length >= 1) {
            this.startCallToUser(msg, false, defaultCallTime);
          } else {
            this.startCallToUser(msg, true);
          }
          if (call_offLine_userids.length >= 1) {
            this.call_data.call_offLine_userids = call_offLine_userids;
            pushMessage({
              to_user: this.call_data.call_offLine_userids,
              push_user: user.name,
              call_type: 1,
            });
            // 离线的也要发
            let service_list = [];
            this.call_data.call_offLine_userids.forEach((item) => {
              service_list.push(item + "_service");
            });
            let service_msg = {
              to_service: service_list,
            };
            // 发送唤醒服务
            doSend(JSON.stringify(service_msg));
          }
        } else {
          // 没有可以拨打的了
          msg["send_type"] = "outTime";
          this.endCallFlow("noanswer", msg);
        }
      },

      async callNext(hangup_user) {
        //在一对多通话时，顺序呼叫时，一个挂断应该拨打给下一个
        console.log(this.call_data.call_sort_userids);
        let sort_index = this.call_data.call_sort_userids.indexOf(hangup_user);
        let to_users = [];

        //多了几个参数，但是没有影响
        let msg = this.call_data;
        msg.send_type = "apply";

        let userInfo = JSON.parse(
          localStorage.getItem(process.env.VUE_APP_USER_KEY)
        );

        //sort_index:-1 一齐拨打的人挂断了
        let defaultCallTime = 60;
        if (sort_index != -1) {
          for (
            let i = sort_index + 1;
            i < this.call_data.call_sort_userids.length;
            i++
          ) {
            let doctor = await GetDoctorDetail(
              this.call_data.call_sort_userids[i]
            );
            if (doctor.data.data.detail.online_status == "online") {
              // 在线
              if (
                doctor.data.data.detail.calling_status != "3" &&
                doctor.data.data.detail.calling_status != "6"
              ) {
                continue;
              }
              msg["offLineCall"] = false;
            } else {
              if (doctor.data.data.detail.push_status !== "can") {
                continue;
              }
              msg["offLineCall"] = true;
            }
            // 对方为可通话状态
            if (doctor.data.data.detail.no_answer_flg == "1") {
              defaultCallTime = 999999;
            }
            to_users = [this.call_data.call_sort_userids[i]];
            break;
          }
          if (to_users.length >= 1) {
            // 顺序拨打未完继续顺序拨打
            msg["to_users"] = to_users;
            this.call_data.to_users = to_users;

            if (msg["offLineCall"]) {
              this.startCallToUser(msg, true);
              pushMessage({
                to_user: to_users,
                push_user: userInfo.name,
                call_type: 1,
              });
            } else {
              this.startCallToUser(msg, false, defaultCallTime);
            }
          } else {
            // 如果没有顺序拨打了，进行一齐拨打
            let call_offLine_userids = [];
            for (let i = 0; i < this.call_data.call_userids.length; i++) {
              let doctor = await GetDoctorDetail(this.call_data.call_userids[i]);
              if (doctor.data.data.detail.online_status == "online") {
                // 在线
                if (
                  doctor.data.data.detail.calling_status != "3" &&
                  doctor.data.data.detail.calling_status != "6"
                ) {
                  continue;
                }
                to_users.push(doctor.data.data.detail.doctor_id);
              } else {
                if (doctor.data.data.detail.push_status !== "can") {
                  continue;
                }
                call_offLine_userids.push(doctor.data.data.detail.doctor_id);
              }
              // 对方为可通话状态
              if (doctor.data.data.detail.no_answer_flg == "1") {
                defaultCallTime = 999999;
              }
            }

            this.call_data.call_userids = to_users;

            if (to_users.length > 1 || call_offLine_userids.length >= 1) {
              // 进行一齐拨打
              msg["to_users"] = to_users;
              this.call_data.to_users = to_users;
              if (to_users.length >= 1) {
                this.startCallToUser(msg, false, defaultCallTime);
              } else {
                this.startCallToUser(msg, true);
              }
              if (call_offLine_userids.length >= 1) {
                this.call_data.call_offLine_userids = call_offLine_userids;
                pushMessage({
                  to_user: this.call_data.call_offLine_userids,
                  push_user: userInfo.name,
                  call_type: 1,
                });
              }
            } else {
              //这里的处理？
              msg["send_type"] = "outTime";
              this.endCallFlow("noanswer", msg);
            }
          }
        } else {
          console.log(this.call_data.call_userids);
          this.call_data.call_userids = this.call_data.call_userids.filter(
            (item) => {
              return item !== hangup_user;
            }
          );

          if (this.call_data.call_userids.length === 0) {
            msg["send_type"] = "outTime";
            this.endCallFlow("noanswer", msg);
          }
        }
      },
      async receiveMsg(json) {
        let receiveMsgItem = JSON.parse(json);
        let userInfo = JSON.parse(
          localStorage.getItem(process.env.VUE_APP_USER_KEY)
        );

        if (receiveMsgItem === "doRefresh") {
          this.refreshPage(false);
        }
        if (receiveMsgItem["send_type"] != "connect") {
          console.log(receiveMsgItem);
        } else {
          // console.log(receiveMsgItem);
          // 是否有人申请登录
          if (receiveMsgItem["check_login"]) {
            let check_login = JSON.parse(receiveMsgItem["check_login"]);
            if (this.login_request_uid != check_login["uid"]) {
              if (check_login["status"] == "wait") {
                this.login_request_uid = check_login["uid"];
                Dialog.confirm({
                  message:
                    "他のユーザーがこのアカウントにログインしようとしています。",
                  confirmButtonText: "許可",
                  cancelButtonText: "拒否",
                })
                  .then(() => {
                    this.agreeLogin(userInfo.login_account_id);
                  })
                  .catch(() => {
                    this.refuseLogin(userInfo.login_account_id);
                  });
                // 重置弹窗计时
                this.clearLoginRequestTimeout();
                // 60s后自动关闭弹窗
                this.login_request_timeout = setTimeout(() => {
                  Dialog.close();
                  this.login_request_timeout = null;
                  this.login_request_uid = null;
                }, 60000);
              } else {
                // 已经同意或拒绝
                this.login_request_uid = null;
              }
            }
          } else {
            if (this.login_request_timeout) {
              // 发起请求方放弃了申请
              Dialog.close();
              this.login_request_uid = null;
            }
            this.clearLoginRequestTimeout();
          }
          // 是否有需要接收的消息
          if (receiveMsgItem["check_notice"] && userInfo.type == "5") {
            this.initNotice();
          }
          // 是否有需要接受的income信息
          if (receiveMsgItem["check_income"] && userInfo.type == "4") {
            this.receiveMsg(receiveMsgItem["income_data"]);
          }
          // 是否有需receiveMsg(要接受的aams信息
          if (receiveMsgItem["check_aams"]) {
            [].concat(JSON.parse(receiveMsgItem["aams_data"])).forEach((data) => {
              this.receiveMsg(JSON.stringify(data));
            });
          }
          // 是否有需receiveMsg(要接受的smartpeep信息
          if (receiveMsgItem["check_smartpeep"]) {
            []
              .concat(JSON.parse(receiveMsgItem["smartpeep_data"]))
              .forEach((data) => {
                this.receiveMsg(JSON.stringify(data));
              });
          }
          // 是否有需receiveMsg(要接受的按钮拨打信息
          if (receiveMsgItem["check_button"]) {
            []
              .concat(JSON.parse(receiveMsgItem["button_data"]))
              .forEach((data) => {
                this.receiveMsg(JSON.stringify(data));
              });
          }
          // 通话状态异常
        }
        //按钮拨打的问题
        if (receiveMsgItem["send_type"] == "onlyButtonCall") {
          if (
            this.callingStatus == "inCalling" ||
            this.callingStatus == "call" ||
            this.checkPage("/roomConversation") ||
            this.checkPage("/singleCall")
          ) {
            return;
          }
          if (userInfo.type == "4") {
            this.startAnswerFlow();
            this.showCallDialog();
            this.showInComing(receiveMsgItem);
            receiveMsgItem["showCall"] = false;
            if (
              !this.receiveCallList.some(
                (item) => item.call_id == receiveMsgItem["call_id"]
              )
            ) {
              this.receiveCallList.push(receiveMsgItem);
            }
            if (userInfo.show_call_no_answer_flg == 1) {
              this.setHangupTimer("answer", 999999, receiveMsgItem);
            } else {
              this.setHangupTimer(
                "answer",
                userInfo.show_call_no_answer_time,
                receiveMsgItem
              );
            }
          } else {
            this.callTeam(receiveMsgItem);
          }
          return;
        } else if (receiveMsgItem["send_type"] == "promptAlert") {
          if (
            this.callingStatus == "inCalling" ||
            this.callingStatus == "call" ||
            this.checkPage("/roomConversation") ||
            this.checkPage("/singleCall")
          ) {
            return;
          }
          if (userInfo.type == "4") {
            // 医生侧
            this.startAnswerFlow();
            this.showCallDialog();
            this.showInComing(receiveMsgItem);
            receiveMsgItem["showCall"] = false;
            if (
              !this.receiveCallList.some(
                (item) => item.call_id == receiveMsgItem["call_id"]
              )
            ) {
              this.receiveCallList.push(receiveMsgItem);
            }
            // 自动挂断
            this.autoHangupTimer[receiveMsgItem["call_id"]] = setTimeout(() => {
              receiveMsgItem["hangup_type"] = "outTime";
              this.hangupCall(receiveMsgItem);
            }, 60 * 1000);
          } else {
            // 患者侧
            // this.callTeam(receiveMsgItem);
          }
          return;
        } else if (receiveMsgItem["send_type"] == "smartpeepAlert") {
          if (
            this.callingStatus == "inCalling" ||
            this.callingStatus == "call" ||
            this.checkPage("/roomConversation") ||
            this.checkPage("/singleCall")
          ) {
            return;
          }
          // 只有医生侧
          this.startAnswerFlow();
          this.showCallDialog();
          this.showInComing(receiveMsgItem);
          if (
            !this.receiveCallList.some(
              (item) => item.call_id == receiveMsgItem["call_id"]
            )
          ) {
            this.receiveCallList.push(receiveMsgItem);
          }
          if (userInfo.show_call_no_answer_flg == 1) {
            this.setHangupTimer("answer", 999999, receiveMsgItem);
          } else {
            this.setHangupTimer(
              "answer",
              userInfo.show_call_no_answer_time,
              receiveMsgItem
            );
          }
        }
        if (receiveMsgItem["send_type"] == "recordMsg") {
          // 不在机能页面
          if (!this.checkPage("/audioBridgeList")) {
            // 开启了自动接受功能
            if (
              userInfo.audio_bridge == 1 &&
              receiveMsgItem["income_type"] == "new"
            ) {
              // 状态不是空闲状态、在通话中、在room中
              if (
                this.callingStatus != "normal" ||
                this.checkPage("/roomConversation") ||
                this.checkPage("/singleCall")
              ) {
                // 去auditolist画面
                Toast(
                  "新しいメッセージがあります、3分以内にインカムページでご確認ください"
                );
                return;
              } else {
                // 判断是否已经读取过本条消息了 如果读取过不需要跳转
                if (receiveMsgItem["read_users"]) {
                  let read_users = receiveMsgItem["read_users"].split(",");
                  if (read_users.includes(userInfo.login_account_id)) {
                    // 已读 跳过
                    return;
                  }
                }
              }
            } else {
              return;
            }
          }
          // 在的话直接接收消息
          this.$router.push({
            path: "/audioBridgeList",
            query: { unique: Date.now() },
          });
          return;
        }

        if (receiveMsgItem["send_type"] == "openPatientMonitor") {
          if (userInfo.type == "5") {
            // 通知患者进入监护模式
            this.monitor({
              toPage: "monitor",
              method: "startBackgroundMonitor",
              ai_mode: receiveMsgItem["ai_mode"],
            });
          }
          return;
        }
        // id:拨打ID
        // send_type apply：请求 answer：回应  hangup:挂断电话
        // call_type 1:患者打出去 2医生打给患者 3 医生打给医生 4 拨打对象正在通话中 7家族打给患者
        // to_users 能接收到消息的对象 数组类型
        // call_user 拨打的人信息
        // call_user_name 拨打人姓名
        // answer_user 接电话的人的信息
        if (receiveMsgItem["send_type"] == "apply") {
          // 收到通话申请
          // msg的流程里，每次数据不一样。所以保存日志需要小心
          // 如果当前在room通话或者监视页面，那么就不接听，返回busy
          if (
            this.callingStatus == "inCalling" ||
            this.callingStatus == "call" ||
            this.checkPage("/roomConversation") ||
            this.checkPage("/singleCall")
          ) {
            // 已经在通话中 返回拒绝消息
            let msg = {
              call_id: receiveMsgItem["call_id"],
              send_type: "hangup",
              hangup_type: "busy",
              hangup_user: userInfo.login_account_id,
              to_users: [receiveMsgItem["call_user"]],
            };
            doSend(JSON.stringify(msg));
          } else {
            //显示来电。
            this.startAnswerFlow();
            this.showInComing(receiveMsgItem);
            // 放入接听电话列表 （20240104:好像没用了）
            this.inCallingInfo = receiveMsgItem;
            // 按钮通话区分
            receiveMsgItem["showCall"] = false;
            if (
              !this.receiveCallList.some(
                (item) => item.call_id == receiveMsgItem["call_id"]
              )
            ) {
              this.receiveCallList.push(receiveMsgItem);
            }

            //医生打给患者时，患者侧设置自动接听。如果这时候患者侧刷新了，那么60s将会挂断
            if ([2, 7].includes(receiveMsgItem["call_type"])) {
              //用护士设置的时间
              if (receiveMsgItem["answer_flg"] === "1") {
                this.setAutoAnswerTimer(receiveMsgItem);
              } else if (userInfo.answer_flg == 1) {
                //用患者设置的时间
                receiveMsgItem["auto_answer_time"] = userInfo.auto_answer_time;
                this.setAutoAnswerTimer(receiveMsgItem);
              }
            }

            //患者打给护士时，护士需要能自动挂断
            if (receiveMsgItem["call_type"] === 1) {
              if (userInfo.no_answer_flg == "1") {
                this.setHangupTimer("answer", 999999, receiveMsgItem);
              } else {
                this.setHangupTimer(
                  "answer",
                  userInfo.no_answer_time,
                  receiveMsgItem
                );
              }
            }
          }
        } else if (receiveMsgItem["send_type"] == "answer") {
          console.log("answer!!!!!");
          if (receiveMsgItem["call_id"] != this.call_data.call_id) {
            return;
          }
          // 清空全部的离线消息
          changeMessageStatus({ to_user: userInfo.login_account_id }).then(
            () => { }
          );
          if (this.callingStatus == "call") {
            // 检测是否还有一齐拨打 如果有发送给对方关闭显示
            if (
              this.call_data.call_type == 1 &&
              this.call_data.call_userids.length > 0
            ) {
              let answer_user_id = receiveMsgItem["answer_user"].substring(
                4,
                4 + 12
              );
              let outTimeToUser = this.call_data.call_userids.filter(
                (indexdata) => {
                  return indexdata !== answer_user_id;
                }
              );
              let msg = {
                call_id: this.call_data.call_id,
                send_type: "outTime",
                to_users: outTimeToUser,
              };
              doSend(JSON.stringify(msg));
            }

            // 对方接收通话 开始建立连接
            this.endCallFlow("answer", receiveMsgItem);
            // 如果在监护模式需要先退出room
            if (this.monitorRoom !== "") {
              this.monitor({
                toPage: "monitor",
                method: "quitMonitor",
                fromPage: "app",
              });
            }
            this.logMessage = receiveMsgItem;
            setTimeout(() => {
              this.$router.push({
                path: "/singleCall",
                query: {
                  callId: receiveMsgItem["call_id"],
                  callType: receiveMsgItem["call_type"],
                  videoOrAudioCall: receiveMsgItem["videoOrAudioCall"],
                  answerUser: receiveMsgItem["answer_user"],
                  userType: "callUser",
                  cameraOpen: receiveMsgItem["cameraOpen"],
                  mikeOpen: receiveMsgItem["mikeOpen"],
                },
              });
            }, 1000);
          }
        } else if (receiveMsgItem["send_type"] == "hangup") {
          if (receiveMsgItem["call_id"] != this.call_data.call_id) {
            return;
          }
          //这是拨打者的处理流程
          if (this.call_data.call_type != 1) {
            receiveMsgItem["send_type"] = "outTime";
            this.endCallFlow(receiveMsgItem["hangup_type"], receiveMsgItem);
            return;
          }
          //一对多的情况下，需要检测是否需要给下一个拨打
          if (this.call_data.call_type == 1) {
            //拨打下一个之前，需要先清空定时器！
            this.clearHangupTimer();
            this.callNext(receiveMsgItem["hangup_user"]);
          }
        } else if (receiveMsgItem["send_type"] == "outTime") {
          //这是接听者的处理流程
          if (this.callingStatus == "beCalled") {
            this.receiveCallList = this.receiveCallList.filter(
              (item) => item.call_id !== receiveMsgItem["call_id"]
            );
            if (this.receiveCallList.length == 0) {
              this.endAnswerFlow("outTime");
            }
          }
        } else if (receiveMsgItem["send_type"] == "offLineCall") {
          // 离线被拨打者上线并回复
          console.log("offLineCall!!!!!!");

          // this.call_data.offLineCall 说明是1对1,或者是顺序拨打中的离线拨打
          // this.call_data.call_offLine_userids 代表一齐拨打中的离线人
          if (this.call_data.offLineCall) {
            // 设置为true意味着 离线拨打者已经上线 是正常拨打的逻辑了
            this.inOffLineCalling = true;
            doSend(JSON.stringify(this.call_data));
            //设置该离线拨打的数据已经处理
            changeMessageStatus({ to_user: userInfo.login_account_id }).then(
              () => { }
            );
          } else if (
            this.call_data.call_offLine_userids &&
            this.call_data.call_offLine_userids.length > 0
          ) {
            // 一齐发送中 有部分是离线拨打的情况
            // 把上线的人放到to_users里面(to_users里都是在线的人)
            // 深拷贝
            let sendMsg = this.initCallMsg("video", 1);
            let userInfo = JSON.parse(
              localStorage.getItem(process.env.VUE_APP_USER_KEY)
            );
            Object.assign(sendMsg, {
              call_user: userInfo.login_account_id,
              call_user_name: userInfo.name,
            });
            sendMsg["call_id"] = this.call_data.call_id;
            sendMsg["to_users"] = [receiveMsgItem["send_user"]];
            doSend(JSON.stringify(sendMsg));
            this.call_data.to_users.push(receiveMsgItem["send_user"]);
          }
        } else if (receiveMsgItem["send_type"] == "multiCall") {
          // 三方通话 a,b通话 拉c进入
          if (receiveMsgItem["type"] == "apply") {
            console.log("收到三方通话请求......");
            if (receiveMsgItem["status"] && receiveMsgItem["status"] == "wait") {
              if(this.checkPage("/singleCall") && this.multicallWaitUser == receiveMsgItem["call_user"]){
                let params = {action_page:"singleCall",method:"joinMultiCallRoom"
                  ,roomId:receiveMsgItem["roomId"] ,call_user:receiveMsgItem["call_user"]};
                this.$store.dispatch('doMethods', params);
                return;
              }
            }
            // C 收到申请进行三方通话
            if (
              this.callingStatus == "inCalling" ||
              this.callingStatus == "call" ||
              this.checkPage("/roomConversation") ||
              this.checkPage("/singleCall")
            ) {
              // 已经在通话中了，返回拒绝消息
              console.log("已经在通话中了，拒绝.....");
              let msg = {
                call_id: receiveMsgItem["call_id"],
                send_type: "multiCall",
                type: "busy",
                to_users: [receiveMsgItem["call_user"]],
              };
              doSend(JSON.stringify(msg));
            } else {
              console.log("显示来电.......");
              // 显示来电
              this.startAnswerFlow();
              this.showInComing();
              if (
                !this.receiveCallList.some(
                  (item) => item.call_id == receiveMsgItem["call_id"]
                )
              ) {
                this.receiveCallList.push(receiveMsgItem);
              }
            }
          } else if (receiveMsgItem["type"] == "outTime") {
            // C 收到A的取消通话
            console.log("对方取消三方通话呼叫......");
            this.receiveCallList = this.receiveCallList.filter(
              (item) => item.call_id !== receiveMsgItem["call_id"]
            );
            if (this.receiveCallList.length == 0) {
              this.endAnswerFlow("outTime");
            }
            this.closeCallDialog();
          } else if (receiveMsgItem["type"] == "notice") {
            // 只有两种状态 暂停/恢复 所以只有三方通话开始的 非申请其他人加入的 另一方能收到
            this.multicallWaitUser = receiveMsgItem["call_user"];
            // 需要去singlecall页面执行
            let params = {
              action_page: "singleCall",
              call_id: receiveMsgItem["call_id"],
              method: receiveMsgItem["method"],
            };
            this.$store.dispatch("doMethods", params);
          } else if (receiveMsgItem["type"] == "busy") {
            // A 收到C返回的拒绝消息
            console.log("对方拒绝多人通话......");
            Dialog.alert({
              message: "現在通話中\n後ほどお掛け直しください",
              theme: "round-button",
              confirmButtonText: "キャンセル",
            });
            if (this.checkPage("/singleCall")) {
              // 如果在通话界面，则恢复通话
              let params = { action_page: "singleCall", method: "reStart" };
              this.$store.dispatch("doMethods", params);
            }
          } else if (receiveMsgItem["type"] == "agree") {
            // A 收到C的同意消息
            console.log("对方同意多人通话......");
            let params = { action_page: "singleCall", method: "createRoom" };
            this.$store.dispatch("doMethods", params);
          } else if (receiveMsgItem["type"] == "joinRoom") {
            console.log("收到了roomID 准备进入");
            // C 收到A发来的roomID
            this.joinMultiCallRoom(receiveMsgItem["roomId"]);
          } else if (receiveMsgItem["type"] == "end") {
            if(this.checkPage("/singleCall") && this.multicallWaitUser == receiveMsgItem["call_user"]){
              // 如果还在通话界面 则直接退出
              this.$router.go(-1);
            }else if(this.checkPage("/roomConversation") ){
              // 在room中 去room页面判断是否还是该通话 如果是则挂断
              let params = {
                action_page: "roomConversation",
                method: "multiCallEnd",
              };
              console.log("11111","发送到roomConversation");
              this.$store.dispatch("doMethods", params);
            }
          } else if (receiveMsgItem["type"] == "offLine") {
            // 离线被拨打者上线并回复
            console.log("离线者上线");
            if (this.checkPage("/singleCall")) {
              // 如果在1对1页面 则是AB通话给C的离线拨打
              let params = { action_page: "singleCall", method: "offLineCall" };
              this.$store.dispatch("doMethods", params);
            } else if (this.checkPage("/roomConversation")) {
              // 如果是在room中，则是AC通话 给B的离线拨打
              let params = {
                action_page: "roomConversation",
                method: "offLineCall",
              };
              this.$store.dispatch("doMethods", params);
            }
            //设置该离线拨打的数据已经处理
            changeMessageStatus({ to_user: userInfo.login_account_id }).then(
              () => { }
            );
          }
        }
      },
      playMsgRinging() {
        this.setMusicSrc();
        if (this.$refs.msgRing) {
          if (this.msgMusicBlob) {
            this.$refs.msgRing.src = this.msgMusicBlob;
          } else if (this.msgMusicSrc !== this.msgMusicSrcLast) {
            this.$refs.msgRing.src = this.msgMusicSrc;
            this.msgMusicSrcLast = this.msgMusicSrc;
          }
          this.$refs.msgRing.currentTime = 0;
          this.$refs.msgRing.play();
        } else {
          setTimeout(() => {
            let msgRing = document.getElementById("msgRingId");
            if (this.msgMusicBlob) {
              msgRing.src = this.msgMusicBlob;
            } else if (this.msgMusicSrc !== this.msgMusicSrcLast) {
              msgRing.src = this.msgMusicSrc;
              this.msgMusicSrcLast = this.msgMusicSrc;
            }
            msgRing.currentTime = 0;
            msgRing.play();
          }, 100);
        }
        try {
          // 铃声震动
          if (navigator.vibrate) {
            navigator.vibrate(1000);
          }
        } catch (error) {
          console.error("error in vibrate");
        }
      },
      //显示来电
      showInComing(msgInfo) {
        this.closeNoAnswerDialog();
        //如果铃声在响 就不用开启
        if (!this.callRingStatus) {
          this.callRingStatus = true;
          this.prepareIosAudioSessionForRing(this.startCallRingAudio);
          try {
            // 铃声震动
            if (navigator.vibrate) {
              navigator.vibrate(1000);
            }
          } catch (error) {
            console.error("error in vibrate");
          }
        }
      },
      initAllTimer() {
        //初始化 通话相关的timer
        this.clearAllAutoAnswerTimer();
        this.clearAllHangupTimer();
        this.clearHangupTimer();
      },
      setAutoAnswerTimer(receiveMsgItem) {
        let auto_answer_time = receiveMsgItem["auto_answer_time"];
        //自动接听的定时器,仅在患者侧才需要，使用之前需要判断类型！
        if (auto_answer_time <= 0) {
          auto_answer_time = 1;
        }
        if (auto_answer_time >= 60) {
          auto_answer_time = 60;
        }
        this.autoAnswerTimer[receiveMsgItem["call_id"]] = setTimeout(() => {
          this.answerCall(receiveMsgItem);
        }, auto_answer_time * 1000);
      },
      clearAllAutoAnswerTimer() {
        // 清空全部自动接听
        for (let call_id in this.autoAnswerTimer) {
          clearTimeout(this.autoAnswerTimer[call_id]);
          delete this.autoAnswerTimer[call_id];
        }
      },
      clearAllHangupTimer() {
        // 清空全部自动挂断
        for (let call_id in this.autoHangupTimer) {
          clearTimeout(this.autoHangupTimer[call_id]);
          delete this.autoHangupTimer[call_id];
        }
      },
      clearAutoAnswerTimer(call_id) {
        // 清空指定自动接听
        if (this.autoAnswerTimer[call_id]) {
          clearTimeout(this.autoAnswerTimer[call_id]);
          delete this.autoAnswerTimer[call_id];
        }
      },
      clearAutoHangupTimer(call_id) {
        // 清空指定定制挂断
        if (this.autoHangupTimer[call_id]) {
          clearTimeout(this.autoHangupTimer[call_id]);
          delete this.autoHangupTimer[call_id];
        }
      },
      setHangupTimer(type, times, hangupItem) {
        if (type == "caller") {
          //拨打者定时
          this.hangupTimer = setTimeout(() => {
            //发送超时的消息给用户
            let to_users = this.call_data.to_users;
            let msg = {
              call_id: this.call_data.call_id,
              send_type: "outTime",
              to_users: to_users,
            };
            if (this.call_data.offLineCall) {
              changeMessageStatus({
                to_user: this.call_data["to_users"][0],
              }).then(() => { });
              if (this.inOffLineCalling) {
                doSend(JSON.stringify(msg));
              }
            } else {
              doSend(JSON.stringify(msg));
            }
            if (this.call_data.call_type == "1" && to_users.length == 1) {
              //认为可能是顺序拨打,挂断后拨打下一个。
              this.callNext(to_users[0]);
            } else {
              //
              this.endCallFlow("onlinetonotonline", msg);
            }
          }, times * 1000);
        } else if (type == "answer") {
          if (times <= 0) {
            times = 1;
          }
          // 接听的话现在可以存在多个定时器 放入对象中
          this.autoHangupTimer[hangupItem["call_id"]] = setTimeout(() => {
            this.hangupCall(hangupItem);
          }, times * 1000);
        }
      },
      clearHangupTimer() {
        if (this.hangupTimer) {
          clearTimeout(this.hangupTimer);
          this.hangupTimer = null;
        }
      },
      saveEndCallMsg() {
        let msg = {
          send_type: "hangup",
          call_id: this.call_data.call_id,
        };
        saveCallLog(msg);
      },
      resetPage() {
        this.call_data = {
          call_id: "",
          callingStatus: "normal",
          call_sort_userids: [],
          call_userids: [],
          call_offLine_userids: [],
        };
        this.inOffLineCalling = false;
        this.inCallingInfo = {};

        this.setCallingStatus("normal");

        this.initAllTimer();

        this.clearLoading();
      },
      saveFcmToken(fcmToken) {
        let userInfo = JSON.parse(
          localStorage.getItem(process.env.VUE_APP_USER_KEY)
        );
        if (
          fcmToken &&
          checkAuthorization() &&
          userInfo &&
          (userInfo.fcm_token == null || userInfo.fcm_token != fcmToken)
        ) {
          SaveFcmToken({ fcmToken: fcmToken }).then(() => { });
        }
      },
      jumpPage(path) {
        if (
          this.callingStatus !== "inCalling" &&
          this.callingStatus !== "call" &&
          !this.checkPage("/roomConversation") &&
          !this.checkPage("/singleCall")
        ) {
          this.$router.push(path);
        }
      },
      checkPage(path) {
        let ret = false;
        if (this.$route.path == path) {
          ret = true;
        }

        return ret;
      },
      connectWebSocket(webSocket) {
        // 连接websocket并且同时更新redis
        // websocket会回一个消息 包含了是否有人想要登录
        if (this.isBackgroundMode) {
          return;
        }
        let callingStatus = 3;
        let isCalling = false;
        let room_id = "";
        //calling_status 1:1对1通话 2:room通话 3:正常状态 4:拨打电话 5:等待接听 6:被监视模式 7:等待离线人上线
        if (this.checkPage("/singleCall")) {
          callingStatus = 1;
          isCalling = true;
        }
        if (this.checkPage("/roomConversation")) {
          callingStatus = 2;
          isCalling = true;
          room_id = this.$route.query.room_id;
        }
        if (this.callingStatus == "call") {
          callingStatus = 4;
          isCalling = false;
        }
        if (this.callingStatus == "beCalled") {
          callingStatus = 5;
          isCalling = false;
        }
        if (this.checkPage("/monitorRoom") || this.monitorRoom !== "") {
          callingStatus = 6;
          isCalling = false;
        }
        let userInfo = JSON.parse(
          localStorage.getItem(process.env.VUE_APP_USER_KEY)
        );
        userInfo.team_id;

        // 发送websocket消息
        webSocket.send(
          JSON.stringify({
            type: "connect",
            callingStatus: callingStatus,
            isCalling: isCalling,
            room_id: room_id,
          })
        );
      },
      clearLoginRequestTimeout() {
        if (this.login_request_timeout) {
          clearTimeout(this.login_request_timeout);
          this.login_request_timeout = null;
        }
      },
      async agreeLogin(login_account_id) {
        await CheckLoginRequest({ status: "agree", id: login_account_id });
        this.clearLoginRequestTimeout();
        // 执行登出操作
        LoginedOut({ token: localStorage.getItem("refreshtoken") }).then(() => {
          const code = localStorage.getItem(process.env.VUE_APP_CODE_KEY);
          Logout();
          if (Janus) {
            Janus.videoPageDestory();
          }
          this.$router.push({
            path: "/login",
            query: {
              code: code,
            },
          });
          setTimeout(() => {
            window.location.reload();
          }, 100);
        });
      },
      async refuseLogin(login_account_id) {
        await CheckLoginRequest({ status: "refuse", id: login_account_id });
        if (this.login_request_timeout) {
          clearTimeout(this.login_request_timeout);
          this.login_request_timeout = null;
        }
      },
      saveVideoRecordLog(
        send_type,
        record_user,
        record_filename,
        status,
        myName,
        remoteName
      ) {
        console.log(send_type, record_user, record_filename, status);
        this.logMessage["send_type"] = send_type;
        this.logMessage["record_user"] = record_user;
        this.logMessage["record_filename"] = record_filename;
        if (myName) {
          this.logMessage["my_name"] = myName;
        }
        if (remoteName) {
          this.logMessage["remote_name"] = remoteName;
        }
        saveVideoRecord({ msg: this.logMessage, status: status }).then((res) => {
          if (res.data.code < 0) {
            Toast("error！");
          }
        });
      },

      getLastRestartExecutionDate() {
        const lastExecution = localStorage.getItem("lastRestartExecutionDate");
        return lastExecution ? new Date(lastExecution) : null;
      },

      setLastRestartExecutionDate(date) {
        localStorage.setItem("lastRestartExecutionDate", date.toISOString());
      },
      restartAndroidApp() {
        this.setLastRestartExecutionDate(new Date());

        try {
          let restartLog = {
            restart_at: new Date(),
            status: "ok",
          }
          if (cordova.plugins && cordova.plugins.RestartPlugin) {
            console.log("RestartPlugin called to restart the app.");
            this.saveRestartLog(restartLog);
            // cordova.plugins.RestartPlugin.restartApp();
            setTimeout(()=>{cordova.plugins.RestartPlugin.restartApp();},1000)
            //添加日志
            // restartLog.status="ok";
          } else {

            restartLog.status = "error";
            this.saveRestartLog(restartLog);
            console.error("RestartPlugin is not available.");
          }
        } catch (error) {
          restartLog.status = "exception";
          this.saveRestartLog(restartLog);
          console.error(
            "An error occurred while executing the restart function:",
            error
          );
        }
      },
      saveRestartLog(newLog) {
        const storageKey = "restartLog";
        const maxLogs = 50;

        // Get current logs from storage
        let savedLogs = JSON.parse(localStorage.getItem(storageKey)) || [];

        // Add the new log
        savedLogs.push(newLog);

        // If there are more than maxLogs, remove the oldest log
        if (savedLogs.length > maxLogs) {
          savedLogs.shift();
        }

        // Save the updated logs to storage
        localStorage.setItem(storageKey, JSON.stringify(savedLogs));
      },
      checkIsNeedRestart() {
        const currentDate = new Date();
        const hour = currentDate.getHours();
        const minute = currentDate.getMinutes();

        // 获取当前页面的 URL
        const url = window.location.href;

        if (url.indexOf("android-") === -1) {
          return false;
        }

        let lastExecutionDate = this.getLastRestartExecutionDate();

        // 48小时
        let executingTime = 1000 * 60 * 60 * 24 * 2;
        if (hour === 22 && minute == 0 && 
        (!lastExecutionDate || 
          currentDate.getTime() - lastExecutionDate.getTime() >= executingTime)) {
          // 需要执行重启操作
          this.refreshPage(true);
        }
        return false;
      },
      async refreshPage(needRestat = false) {
        const callingStatus = this.$store.state.callingStatus;
        const needRefreshStatus = this.$store.state.needRefreshStatus;
        let canReloadPage = false;

        if (this.checkPage("/singleCall")) {
          canReloadPage = true;
        }

        if (this.checkPage("/roomConversation")) {
          canReloadPage = true;
        }

        if (
          callingStatus == 3 &&
          this.needRefresh &&
          needRefreshStatus &&
          !canReloadPage &&
          this.netOnline &&
          !this.isRecordingAudio
        ) {
          if (needRestat) {
            this.restartAndroidApp();
          } else {
            window.location.reload();
          }

        } else {
          console.log("not need reload");
        }
      },
      async checkDevicePermission() {
        let hasPermission = localStorage.getItem("hasPermission");

        //只检测一次
        if (hasPermission) {
          console.log("hasPermission");
          return;
        }

        console.log("checkDevicePermission");
        let constraints = {
          audio: true,
          video: true,
        };

        try {
          let stream = await navigator.mediaDevices.getUserMedia(constraints);
          console.log("获取设备音视频流成功", stream);

          localStorage.setItem("hasPermission", true);
          // 关闭设备流
          let tracks = stream.getTracks();
          tracks.forEach(function (track) {
            track.stop();
          });
        } catch (error) {
          localStorage.removeItem("hasPermission");

          console.error("获取设备音视频流失败", error);
        }
      },
      async checkAndroidPermission() {
        //检测安卓的权限
        const PERMISSIONS = {
          CAMERA: {
            type: "CAMERA",
            title: "カメラの権限",
            message: "カメラの使用権限がありません。追加しますか？",
          },
          RECORD_AUDIO: {
            type: "RECORD_AUDIO",
            title: "マイクの権限",
            message: "マイクの使用権限がありません。追加しますか？",
          },
          // SYSTEM_ALERT_WINDOW: {
          //   type: 'SYSTEM_ALERT_WINDOW',
          //   title: 'アプリの起動権限',
          //   message: 'アプリの起動権限がありません。追加しますか？'
          // }
        };
        const permissions = Object.values(PERMISSIONS);
        for (const permission of permissions) {
          const result = await this.handlePermission(permission);
          if (!result) {
            console.log(`${permission.title}の取得に失敗しました`);
            continue;
          }
        }
      },

      async handlePermission(permission) {
        try {
          const hasPermission = await this.checkPermission(permission.type);
          if (!hasPermission) {
            const dialogResult = await this.showPermissionDialog(
              permission.title,
              permission.message
            );
            if (dialogResult) {
              const granted = await this.requestPermission(permission.type);
              if (!granted) {
                console.log(`${permission.title}が拒否されました`);
                return false;
              }
            } else {
              console.log(
                `${permission.type}の権限リクエストがキャンセルされました`
              );
              return false;
            }
          }
          return true;
        } catch (error) {
          console.log(
            "権限申請に失敗しました。手動で権限をオープンしてください",
            error
          );
          return false;
        }
      },
      async checkPermission(permissionType) {
        return new Promise((resolve, reject) => {
          cordova.plugins.permissions.checkPermission(
            cordova.plugins.permissions[permissionType],
            (status) => resolve(status.hasPermission),
            (error) => reject(error)
          );
        });
      },
      async requestPermission(permissionType) {
        return new Promise((resolve, reject) => {
          cordova.plugins.permissions.requestPermission(
            cordova.plugins.permissions[permissionType],
            (status) => resolve(status.hasPermission),
            (error) => reject(error)
          );
        });
      },
      async showPermissionDialog(title, message) {
        return Dialog.confirm({
          title: title,
          message: message,
          confirmButtonText: "設定へ",
          cancelButtonText: "キャンセル",
        });
      },
      //显示接听用的dialog
      showCallDialog() {
        this.showTop = true;
        this.showMask = true;
      },
      closeCallDialog() {
        //防止误关闭
        if (!this.showTop) {
          this.stopCallRingAudio();
          return this.showTop;
        }
        this.showTop = false;
        this.showMask = false;
        this.stopCallRingAudio();
      },
      //用户点击接听电话
      answerCall(answerItem) {
        // 20240705 aams拨打不需要接听了
        // && answerItem.aams_doctors
        if (answerItem.method == "promptAlert") {
          answerItem["hangup_type"] = "answer";
          this.hangupCall(answerItem);
          // aams并且是后端发来的（患者不在线），发送给其他的挂断
          let msg = {
            call_id: answerItem.call_id,
            send_type: "outTime",
            to_users: answerItem.aams_doctors,
          };
          doSend(JSON.stringify(msg));
          return;
        }
        // smartpeep
        if (answerItem.method == "smartpeepAlert") {
          answerItem["hangup_type"] = "answer";
          this.hangupCall(answerItem);
          // smartpeep是后端发来的，发送给其他的挂断
          let msg = {
            call_id: answerItem.call_id,
            send_type: "outTime",
            to_users: answerItem.smartpeep_doctors,
          };
          doSend(JSON.stringify(msg));
          return;
        }
        if (answerItem.method == "onlyButtonCall" && answerItem.button_doctors) {
          answerItem["hangup_type"] = "answer";
          this.hangupCall(answerItem);
          // button并且是后端发来的（患者不在线），发送给其他的挂断
          let msg = {
            call_id: answerItem.call_id,
            send_type: "outTime",
            to_users: answerItem.button_doctors,
          };
          doSend(JSON.stringify(msg));
          return;
        }
        if (this.callingStatus == "inCalling") {
          // 预防定时器过多出错同时接听两个
          return;
        }
        this.setCallingStatus("inCalling");
        // 清空定时器
        this.initAllTimer();
        // 如果在监护模式 等待退出再接通
        if (this.checkPage("/monitorRoom") || this.monitorRoom !== "") {
          this.monitor({
            toPage: "monitor",
            method: "quitMonitor",
            fromPage: "app",
          });
          setTimeout(() => {
            this.realAnswerCall("monitorRoom", answerItem);
          }, 1000);
        } else {
          this.realAnswerCall("normalCall", answerItem);
        }
      },
      realAnswerCall(type, answerItem) {
        let userInfo = JSON.parse(
          localStorage.getItem(process.env.VUE_APP_USER_KEY)
        );

        if (answerItem.method == "multiCall") {
          if (answerItem.status && answerItem.status == "wait") {
            // 进入多人通话room
            this.joinMultiCallRoom(answerItem.roomId);
          } else {
            // 三方通话 告知对方已同意
            let msg = {
              call_id: answerItem["call_id"],
              send_type: "multiCall",
              type: "agree",
              to_users: [answerItem["call_user"]],
            };
            doSend(JSON.stringify(msg));
          }
        } else {
          // 接听电话 返回给拨打者的janusId
          let returnMsg = answerItem;
          returnMsg["send_type"] = "answer";
          returnMsg["to_users"] = [answerItem["call_user"]];
          //设置janus id
          let registerName =
            process.env.VUE_APP_JANUS_USERNAME +
            userInfo.type +
            "_" +
            userInfo.login_account_id +
            "_" +
            randNumStr(4) +
            "_" +
            userInfo.name;
          returnMsg["answer_user"] = registerName;
          this.logMessage = returnMsg;
          //页面跳转
          this.$router.push({
            path: "/singleCall",
            query: {
              callId: answerItem["call_id"],
              callType: answerItem["call_type"],
              videoOrAudioCall: answerItem["videoOrAudioCall"],
              answerUser: registerName,
              userType: "answerUser",
              monitorType: type,
            },
          });
          // 发送消息
          doSend(JSON.stringify(returnMsg));
        }
        // 给其他打过来的电话都挂断
        this.receiveCallList.forEach((receiveItem) => {
          if (
            answerItem["call_id"] !== receiveItem["call_id"] &&
            !receiveItem["showCall"]
          ) {
            let msg = {
              call_id: receiveItem["call_id"],
              send_type: "hangup",
              hangup_type: "busy",
              hangup_user: userInfo.login_account_id,
              to_users: [receiveItem["call_user"]],
            };
            doSend(JSON.stringify(msg));
          }
        });
        // 清空接听电话清单
        this.receiveCallList = [];
        this.endAnswerFlow("answer");
      },
      hangupCall(hangupItem) {
        // 清除对应的定时器
        this.clearAutoHangupTimer(hangupItem.call_id);
        if (!hangupItem.showCall && hangupItem.method == "promptAlert") {
          if (!hangupItem["hangup_type"]) {
            hangupItem["hangup_type"] = "hangup";
          }
          saveCallLog(hangupItem);
        } else if (hangupItem.method == "smartpeepAlert") {
          if (!hangupItem["hangup_type"]) {
            hangupItem["hangup_type"] = "hangup";
          }
          saveCallLog(hangupItem);
        } else if (hangupItem.method == "multiCall") {
          // 三方通话挂断
          let msg = {
            call_id: hangupItem["call_id"],
            send_type: "multiCall",
            type: "busy",
            to_users: [hangupItem["call_user"]],
          };
          doSend(JSON.stringify(msg));
        } else {
          // 发送挂断请求,除了aams都要发
          let userInfo = JSON.parse(
            localStorage.getItem(process.env.VUE_APP_USER_KEY)
          );
          let msg = {
            call_id: hangupItem.call_id,
            send_type: "hangup",
            //因用户点击而挂断
            hangup_type: "userClick",
            hangup_user: userInfo.login_account_id,
            to_users: [hangupItem["call_user"]],
          };
          doSend(JSON.stringify(msg));
        }
        if (
          !hangupItem.showCall &&
          hangupItem.method == "onlyButtonCall" &&
          hangupItem.button_doctors
        ) {
          if (!hangupItem["hangup_type"]) {
            hangupItem["hangup_type"] = "hangup";
          }
          saveCallLog(hangupItem);
        }

        this.receiveCallList = this.receiveCallList.filter(
          (item) => item.call_id !== hangupItem.call_id
        );
        if (this.receiveCallList.length == 0) {
          this.endAnswerFlow("hangup");
        }
      },
      iosOrAndroid() {
        let url = window.location.href;
        if (url.indexOf("ios") !== -1) {
          console.log("URL contains 'ios'");
          this.isIos = true;
        } else {
          console.log("URL does not contain 'ios'");
          this.isIos = false;
        }
        //
      },
    },
    watch: {
      screenWidth: function (n, o) { },
      $route(newValue, oldValue) {
        // 如果是在监听模式退出的 需要返回到监听页面
        // if(oldValue.path == "/singleCall" && oldValue.query.monitorType =="monitorRoom"){
        //   this.monitor({toPage:"monitor",method:"startMonitor"})
        // }
        // 如果是登录后的页面 并且没有初始化过 进行janus初始化
        if (!loginIgnore.includes(newValue) && !this.webSocketHasRegisted) {
          this.initWebSocket();
        }
        if (!this.ignoreRefresh.includes(newValue)) {
          this.needRefresh = true;
        } else {
          this.needRefresh = false;
        }
        // 页面有变化时、清空multicallWaitUser
        this.multicallWaitUser = null;
      },
    },
    computed: {
      availHeight: function () {
        return window.screen.availHeight + "px";
      },
      noticeViewportWidthValue() {
        return this.noticeViewportWidthPx || this.screenWidth || window.innerWidth || 0;
      },
      noticeViewportHeightValue() {
        return (
          this.noticeViewportHeightPx ||
          window.innerHeight ||
          document.documentElement.clientHeight ||
          0
        );
      },
      noticeCompactLevel() {
        const viewportWidth = this.noticeViewportWidthValue;
        const viewportHeight = this.noticeViewportHeightValue;
        const isLandscape = viewportWidth > viewportHeight;
        if (viewportHeight <= 280) {
          return "ultra";
        }
        if (isLandscape && viewportHeight <= 360) {
          return "ultra";
        }
        if (viewportHeight <= 360) {
          return "compact";
        }
        if (isLandscape && viewportHeight <= 460) {
          return "compact";
        }
        return "normal";
      },
      noticeMinVisibleLines() {
        return this.noticeCompactLevel === "ultra" ? 1 : 2;
      },
      noticeDialogFontScale() {
        if (this.noticeCompactLevel === "ultra") {
          return 0.72;
        }
        if (this.noticeCompactLevel === "compact") {
          return 0.86;
        }
        return 1;
      },
      dialogFontSize() {
        const viewportWidth = this.noticeViewportWidthValue;
        const viewportHeight = this.noticeViewportHeightValue;
        const shortSide = Math.min(viewportWidth, viewportHeight || viewportWidth);
        const isWideScreen = shortSide >= 750;
        const fontSizeMap = {
          1: isWideScreen ? "2.8rem" : "2rem",
          2: isWideScreen ? "4.2rem" : "3rem",
          3: isWideScreen ? "6rem" : "4.4rem",
        };
        const baseRem = parseFloat(
          fontSizeMap[Number(this.fullScreenCallFontSize)] || fontSizeMap[2]
        );
        return (baseRem * this.noticeDialogFontScale).toFixed(2) + "rem";
      },
      noticeIsScroll() {
        return String(this.noticeItem?.fixed_type) === "1";
      },
      noticeNormalizedContent() {
        return String(this.noticeItem?.content || "");
      },
      noticeScrollNeedsAnimation() {
        return this.noticeScrollShouldAnimate;
      },
      noticeScrollStyle() {
        const style = {
          color: this.noticeColor,
          visibility: this.noticeScrollReady ? "visible" : "hidden",
          transform: "translateX(" + this.noticeScrollTranslateXPx + "px)",
          transition:
            this.noticeScrollReady &&
            this.noticeScrollNeedsAnimation &&
            this.noticeScrollTransitionEnabled
              ? "transform " + this.noticeScrollAnimationDurationMs + "ms linear"
              : "none",
        };

        if (!this.noticeIsScroll) {
          return style;
        }

        return style;
      },
      noticeScrollFrameStyle() {
        const defaultFrameHeight = Math.max(
          this.noticeScrollLineHeightPxValue + 8,
          0
        );
        return {
          height:
            this.noticeScrollFrameHeightPx > 0
              ? this.noticeScrollFrameHeightPx + "px"
              : defaultFrameHeight + "px",
        };
      },
      noticeDialogWrapStyle() {
        if (this.noticeCompactLevel === "ultra") {
          return {
            width: "min(96vw, 1560px)",
          };
        }
        if (this.noticeCompactLevel === "compact") {
          return {
            width: "min(95vw, 1480px)",
          };
        }
        return {};
      },
      noticePanelStyle() {
        if (this.noticeCompactLevel === "ultra") {
          return {
            padding: "0.55rem 0.8rem",
          };
        }
        if (this.noticeCompactLevel === "compact") {
          return {
            padding: "0.8rem 1rem",
          };
        }
        return {};
      },
      noticeTitleStyle() {
        if (this.noticeCompactLevel === "ultra") {
          return {
            fontSize: "1.1rem",
            lineHeight: "1.12",
            paddingBottom: "0.3rem",
          };
        }
        if (this.noticeCompactLevel === "compact") {
          return {
            fontSize: "1.35rem",
            lineHeight: "1.16",
            paddingBottom: "0.42rem",
          };
        }
        return {};
      },
      noticeContentAreaStyle() {
        if (this.noticeCompactLevel === "ultra") {
          return {
            marginTop: "0.45rem",
          };
        }
        if (this.noticeCompactLevel === "compact") {
          return {
            marginTop: "0.65rem",
          };
        }
        return {};
      },
      noticeStaticContentStyle() {
        return {
          maxHeight:
            this.noticeStaticMaxHeightPx > 0
              ? this.noticeStaticMaxHeightPx + "px"
              : "calc(var(--tsunagaru-notice-viewport-height, 100vh) - 16rem)",
        };
      },
      dialogFontSizePxValue() {
        const rootFontSize = parseFloat(
          window.getComputedStyle(document.documentElement).fontSize
        );
        const baseFontSize = Number.isFinite(rootFontSize) ? rootFontSize : 16;
        const remValue = parseFloat(this.dialogFontSize) || 3;
        return Math.max(Math.round(remValue * baseFontSize), 16);
      },
      noticeScrollLineHeightPxValue() {
        return Math.max(
          Math.round(this.dialogFontSizePxValue * 1.38),
          this.dialogFontSizePxValue
        );
      },
      noticeCloseButtonStyle() {
        if (this.noticeCompactLevel === "ultra") {
          return {
            marginTop: "0.45rem",
            fontSize: "1rem",
            padding: "0.24rem 0.72rem",
            gap: "0.28rem",
          };
        }
        if (this.noticeCompactLevel === "compact") {
          return {
            marginTop: "0.6rem",
            fontSize: "1.15rem",
            padding: "0.3rem 0.86rem",
            gap: "0.32rem",
          };
        }
        return {};
      },
      noticeCloseButtonIconStyle() {
        if (this.noticeCompactLevel === "ultra") {
          return {
            width: "0.95rem",
            height: "0.95rem",
            fontSize: "0.75rem",
          };
        }
        if (this.noticeCompactLevel === "compact") {
          return {
            width: "1.05rem",
            height: "1.05rem",
            fontSize: "0.8rem",
          };
        }
        return {};
      },
      noticeLeaveShowStyle() {
        if (this.noticeCompactLevel === "ultra") {
          return {
            marginTop: "0.26rem",
            fontSize: "0.86rem",
          };
        }
        if (this.noticeCompactLevel === "compact") {
          return {
            marginTop: "0.35rem",
            fontSize: "0.96rem",
          };
        }
        return {};
      },
      noticeScrollTextStyle() {
        return {
          display: "inline-block",
          width: "max-content",
          maxWidth: "none",
          fontSize: this.dialogFontSizePxValue + "px",
          lineHeight: this.noticeScrollLineHeightPxValue + "px",
          whiteSpace: "nowrap",
          wordBreak: "normal",
          overflowWrap: "normal",
          textAlign: "left",
        };
      },
      noticeStaticTextStyle() {
        return {
          fontSize: this.dialogFontSizePxValue + "px",
          lineHeight: this.noticeScrollLineHeightPxValue + "px",
          paddingBottom: "4px",
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
          overflowWrap: "anywhere",
          textAlign: "left",
        };
      },
    },
  };
</script>

<style>
  :root {
    --tsunagaru-safe-area-top: 0px;
    --tsunagaru-safe-area-top: constant(safe-area-inset-top);
    --tsunagaru-safe-area-top: env(safe-area-inset-top);
    --tsunagaru-safe-area-bottom: 0px;
    --tsunagaru-safe-area-bottom: constant(safe-area-inset-bottom);
    --tsunagaru-safe-area-bottom: env(safe-area-inset-bottom);
    --tsunagaru-notice-viewport-width: 100vw;
    --tsunagaru-notice-viewport-height: 100vh;
    --tsunagaru-notice-visual-top: 0px;
    --tsunagaru-notice-visual-bottom: 0px;
    --tsunagaru-notice-top-reserve: 14px;
    --tsunagaru-notice-bottom-reserve: 12px;
  }

  /* body {
    padding-top: constant(safe-area-inset-top);
    padding-bottom: constant(safe-area-inset-bottom);
    padding-top: env(safe-area-inset-top);
    padding-bottom: env(safe-area-inset-bottom);
} */
  body {
    background: #f4fbff;
  }

  html,
  body,
  #app {
    height: 100vh;
    overflow: auto;
  }

  body {
    font-size: 16px;
    background-color: #f4fbff;
    -webkit-font-smoothing: antialiased;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
  }

  .video-all {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .video-main {
    width: 100%;
    height: 100%;
    background-color: rgba(159, 161, 160, 0.726);
  }

  .video-main-text {
    display: table;
  }

  .video-main-text span {
    display: table-cell;
    vertical-align: middle;
    text-align: center;
    font-size: 20px;
  }

  .video-secondary {
    width: 36%;
    height: 200px;
    background-color: rgb(231, 229, 233);
    top: constant(safe-area-inset-top);
    top: env(safe-area-inset-top);
    right: 15px;
    position: absolute;
  }

  .video-secondary-text {
    display: table;
  }

  .video-secondary-text span {
    display: table-cell;
    vertical-align: middle;
    text-align: center;
    font-size: 20px;
  }

  /* 来电提示 */
  div.popContainer {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 9;
  }

  .showtop {
    width: 100%;
    height: 90px;
    background-color: antiquewhite;
    border-radius: 0 0 30px 30px;
    position: absolute;
    top: constant(safe-area-inset-top);
    top: env(safe-area-inset-top);
    z-index: 99;
    animation-name: top-show;
    animation-duration: 0.5s;
  }

  .showtop-ipad {
    width: 66%;
    height: 90px;
    background-color: antiquewhite;
    border-radius: 0 0 30px 30px;
    position: absolute;
    right: 17%;
    top: 0;
    z-index: 99;
    animation-name: top-show;
    animation-duration: 0.5s;
  }

  .call-top {
    display: flex;
    align-items: center;
    justify-content: space-around;
    animation-name: top-show;
    animation-duration: 1s;
    width: 100%;
  }

  .call-top-1 {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    width: 350px;
    height: 90px;
    justify-content: space-around;
  }

  .call-top-user {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background-color: #95d53a;
    text-align: center;
  }

  .call-top-call {
    display: flex;
    flex-direction: column;
  }

  .call-top-img {
    width: 35%;
    animation-delay: 0s;
    animation-name: shock;
    animation-duration: 0.3s;
    animation-iteration-count: 99999;
    animation-direction: 30s;
    animation-timing-function: linear;
  }

  .call-top-img-ipad {
    width: 30%;
    animation-delay: 0s;
    animation-name: shock;
    animation-duration: 0.3s;
    animation-iteration-count: 99999;
    animation-direction: 30s;
    animation-timing-function: linear;
  }

  .call-top-right {
    display: flex;
    justify-content: space-evenly;
  }

  @keyframes top-show {
    0% {
      height: 0px;
    }

    100% {
      height: 90px;
    }
  }

  @keyframes shock {
    0% {
      margin-left: 0px;
      margin-right: 0px;
      margin-top: 0px;
    }

    100% {
      margin-left: 0px;
      margin-right: 0px;
      margin-top: 5px;
    }
  }

  .shareScreenTitle {
    position: absolute;
    top: 50px;
    color: red;
    left: 43%;
    z-index: 1;
  }

  .curbitrate {
    position: absolute;
    bottom: 0;
    right: 20px;
    z-index: 1;
  }

  .information-top {
    display: flex;
    flex-direction: column;
    margin: 10px;
  }

  .information-lock {
    display: flex;
    flex-direction: column;
    margin: 10px;
    width: 65%;
  }

  .showinformation-top {
    width: 100%;
    min-height: 90px;
    background-color: antiquewhite;
    border-radius: 0 0 30px 30px;
    position: absolute;
    top: constant(safe-area-inset-top);
    top: env(safe-area-inset-top);
    z-index: 99;
    animation-name: top-show;
    animation-duration: 0.5s;
  }

  .showinformation-top-ipad {
    width: 66%;
    min-height: 90px;
    background-color: antiquewhite;
    border-radius: 0 0 30px 30px;
    position: absolute;
    right: 17%;
    top: 0;
    z-index: 99;
    animation-name: top-show;
    animation-duration: 0.5s;
  }

  .showinlock {
    width: 100%;
    min-height: 90px;
    background-color: antiquewhite;
    border-radius: 30px;
    position: absolute;
    top: constant(safe-area-inset-top);
    top: env(safe-area-inset-top);
    z-index: 99;
    animation-name: top-show;
    animation-duration: 0.5s;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .showlock-ipad {
    width: 66%;
    min-height: 90px;
    background-color: antiquewhite;
    border-radius: 30px;
    position: absolute;
    right: 17%;
    top: 0;
    z-index: 99;
    animation-name: top-show;
    animation-duration: 0.5s;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .information-lock-user {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background-color: #95d53a;
    text-align: center;
  }

  .information-lock-time {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .page-app-noticeArea .notice_dialog {
    width: min(92vw, 1280px);
    max-width: 100%;
    max-height: 100%;
    min-height: 0;
    padding: 0;
    box-sizing: border-box;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .page-app-noticeArea .notice_panel {
    background: #ffffff;
    border-radius: 10px;
    padding: 1.1rem 1.2rem;
    width: 100%;
    max-height: 100%;
    min-height: 0;
    box-sizing: border-box;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    flex: 0 1 auto;
  }

  .page-app-noticeArea .notice_title {
    border-bottom: 1px solid #cfd4da;
    font-weight: bold;
    font-size: clamp(1.8rem, 4.2vw, 3rem);
    line-height: 1.25;
    padding-bottom: 0.75rem;
    text-align: left;
    word-break: break-word;
  }

  .page-app-noticeArea .notice_title span {
    display: block;
    white-space: pre-wrap;
  }

  .page-app-noticeArea .notice_content {
    word-wrap: break-word;
    margin-top: 1rem;
    line-height: 1.3;
    min-height: 0;
  }

  .page-app-noticeArea .notice_content_static {
    overflow-y: auto;
    flex: 0 1 auto;
  }

  .page-app-noticeArea .notice_static {
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .page-app-noticeArea .notice_content_scroll {
    position: relative;
    overflow: hidden;
    flex: 0 1 auto;
    display: flex;
    align-items: center;
  }

  .page-app-noticeArea .notice_content_track {
    display: inline-block;
    will-change: transform;
    width: max-content;
    max-width: none;
  }

  .page-app-noticeArea .notice_static span {
    white-space: pre-wrap;
    display: block;
    text-align: left;
    box-sizing: border-box;
  }

  .page-app-noticeArea .notice_scroll_text {
    display: inline-block;
    text-align: left;
    width: max-content;
    box-sizing: border-box;
  }

  .page-app-noticeArea .notice_scroll_placeholder {
    visibility: hidden;
  }

  .page-app-noticeArea .notice_close_button {
    margin-top: 0.9rem;
    border: 0;
    border-radius: 999px;
    background: #e53d34;
    color: #ffffff;
    font-size: 1.6rem;
    font-weight: bold;
    line-height: 1;
    padding: 0.45rem 1.2rem;
    display: inline-flex;
    align-items: center;
    gap: 0.45rem;
  }

  .page-app-noticeArea .notice_close_button-icon {
    width: 1.4rem;
    height: 1.4rem;
    border-radius: 50%;
    border: 1px solid #ffffff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 1.1rem;
    line-height: 1;
  }

  .page-app-noticeArea .notice_leave_show {
    margin-top: 0.6rem;
    font-size: 1.3rem;
    color: #ffffff;
    text-align: center;
    width: 100%;
  }

  .page-app-noticeArea .notice_leave_show span {
    display: inline-block;
    max-width: 100%;
    white-space: nowrap;
  }

  @media (orientation: landscape) {
    .page-app-noticeArea .notice_dialog {
      width: min(94vw, 1560px);
    }

    .page-app-noticeArea .notice_panel {
      padding: 1rem 1.4rem;
    }
  }

  @media (orientation: landscape) and (max-height: 620px) {
    .page-app-noticeArea .notice_panel {
      padding: 0.9rem 1.2rem;
    }

    .page-app-noticeArea .notice_title {
      font-size: clamp(1.5rem, 3vw, 2.3rem);
      padding-bottom: 0.55rem;
    }

    .page-app-noticeArea .notice_content {
      margin-top: 0.75rem;
    }

    .page-app-noticeArea .notice_close_button {
      margin-top: 0.7rem;
      font-size: 1.35rem;
      padding: 0.35rem 1rem;
    }

    .page-app-noticeArea .notice_leave_show {
      margin-top: 0.4rem;
      font-size: 1.05rem;
    }
  }

  .noAnswerDialog .van-dialog__message {
    font-size: 20px;
  }
</style>
